export default {
  common: {
    requests: 'Requests',
    request: 'Request',
    loading: 'Loading...',
    signUp: 'Sign up',
    logOut: 'Log out',
    seeAll: 'See all',
    follow: 'Follow',
    unfollow: 'Unfollow',
    email: 'Email',
    fullName: 'Full name',
    password: 'Password',
    next: 'Next',
    continue: 'Continue',
    addNew: 'Add new',
    type: 'Type',
    typeYourMessage: 'Type your message',
    yourMessage: 'Your message',
    message: 'Message',
    shoutOut: 'Shoutout',
    story: 'Story',
    chat: 'Chat',
    featureComingSoon: 'This feature is coming soon!',
    okay: 'Okay',
    react: 'React',
    send: 'Send',
    delete: 'Delete',
    cancel: 'Cancel',
    yes: 'Yes',
    no: 'No',
    search: 'Search',
    back: 'Back',
    goToHome: 'Go to Home',
    addShoutout: 'Add shoutout',
    player: 'Player',
    text: 'Text',
    video: 'Video',
    comment: 'Comment',
    team: 'Team',
    country: 'Country',
    city: 'City',
    userName: 'Username',
    following: 'Following',
    followers: 'Followers',
    referals: 'Referrals',
    athletes: 'Athletes',
    shoutouts: 'Shoutouts',
    showMore: 'Show More',
    showLess: 'Show less',
    sport: 'Sport',
    position: 'Position',
    league: 'League',
    info: 'Info',
    repost: 'Repost',
    share: 'Share',
    confirmed: 'Confirmed',
    refused: 'Refused',
    pending: 'Pending',
    canceled: 'Canceled',
    trending: 'Trending',
    latest: 'Latest',
    noData: 'No data',
    from: 'from',
    to: 'to',
    settings: 'Settings',
    areYouSure: 'Are you sure',
    profile: 'Profile',
    accept: 'Accept',
    refuse: 'Refuse All',
    missing: 'Missing',
    select: 'Select',
    currency: 'Currency',
    zipCode: 'ZIP Code',
    goBack: 'Go back',
    done: 'Done',
    remove: 'Remove',
    date: 'Date',
    description: 'Description',
    amount: 'Amount',
    upload: 'Upload',
    getApp: 'Get APP',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    confirm: 'Confirm',
    confirmAll: 'Confirm All',
    login: 'Login',
    ad: 'AD',
    aboutUs: 'About us',
    fan: 'Fan',
    athlete: 'Athlete',
    stats: 'Stats',
    posts: 'Posts',
    store: 'Store',
    or: 'Or',
    and: 'and',
    byRegisteringAgree: 'By registering you agree to our',
    shoutout: 'Shout out',
    proceed: 'Proceed',
    dismiss: 'Dismiss',
    save: 'Save',
    discard: 'Discard',
    submit: 'Submit',
    live: 'Live',
    openInbox: 'Open inbox',
    home: 'Home',
    searchDotDotDot: 'Search...',
    subscribers: 'Subscribers',
    subscribed: 'Subscribed',
    subscribe: 'Subscribe',
    unsubscribe: 'Unsubscribe',
    fans: 'Fans',
    teams: 'Teams',
    setup: 'Setup',
    feed: 'Feed',
    messages: 'Messages',
    earlier: 'Earlier',
    apply: 'Apply',
    openInApp: 'Open in app',
    oneOnOnes: 'Face2Face',
    sort: 'Sort',
    comingSoon: 'Coming soon',
    goLive: 'Go live',
    total: 'Total',
    pay: 'Pay {{amount}}',
    free: 'free',
    location: 'Location',
    countries: 'Countries',
    more: 'more',
    less: 'less',
    block: 'Block',
    unblock: 'Unblock',
    privacyPolicy: 'Privacy Policy',
    termsAndConditions: 'Terms and Conditions',
    createNew: 'Create New',
    game: 'Game',
    unlock: 'Unlock',
    post: 'Post',
    uploadFile: 'Upload file',
    checkIn: 'Check In',
    unregisteredType: 'Type is not registered',
    required: 'Required',
    create: 'Create',
    reply: 'Reply',
    caption: 'Caption',
    optional: 'optional',
    face2face: 'Face2Face',
    adPlayaz: 'AdPlayaz',
    activateFancamLive: 'Activate Fancam React',
    activateFancamChallenge: 'Activate Fancam Challenge',
    playToWinPoll: 'Play to Win: Poll',
    playToWinQuickQuiz: 'Play to Win: Quick Quiz',
    predictScore: 'Predict the Score',
    noPosts: 'No Posts',
    noShoutouts: 'No Shoutouts',
    updateNow: 'Update Now',
    goHome: 'Go Home',
    add: 'Add'
  },
  gloryBoard: {
    title: 'Match-Day GloryBoard',
    close: 'Close',
    weeklyWinnerHeadingFirst: 'Congratulations, {{name}}! 🏆',
    weeklyWinnerAchievementFirst: "You finished 1st on this week's Match-Day Glory Board.",
    weeklyWinnerSupportingFirst: 'Defend your spot next week and invite your friends to compete.',
    weeklyWinnerHeadingSecond: 'Congratulations, {{name}}! 🥈',
    weeklyWinnerAchievementSecond: "You finished 2nd on this week's Match-Day Glory Board.",
    weeklyWinnerSupportingSecond: 'Aim for the top spot next week and invite your friends to compete.',
    weeklyWinnerHeadingThird: 'Congratulations, {{name}}! 🥉',
    weeklyWinnerAchievementThird: "You finished 3rd on this week's Match-Day Glory Board.",
    weeklyWinnerSupportingThird: 'Climb even higher next week and invite your friends to compete.'
  },
  sports: {
    americanFootball: 'American Football',
    baseball: 'Baseball',
    basketball: 'Basketball',
    boxing: 'Boxing',
    cricket: 'Cricket',
    soccer: 'Soccer',
    mma: 'Mixed Martial Arts (MMA)',
    race: 'Race car driving',
    tennis: 'Tennis',
    carRace: 'Race Car Driving',
    acrobatics: 'Acrobatics',
    airSports: 'Air Sports',
    archery: 'Archery',
    combatSports: 'Combat Sports',
    cycling: 'Cycling',
    cueSports: 'Cue Sports',
    equestrianSports: 'Equestrian Sports',
    golf: 'Golf',
    handball: 'Handball',
    iceSports: 'Ice Sports',
    lacrosse: 'Lacrosse',
    polo: 'Polo',
    weightlifting: 'Weightlifting',
    rowing: 'Rowing',
    softball: 'Softball',
    rugby: 'Rugby',
    volleyball: 'Volleyball',
    coachingMentoring: 'Coaching & Mentoring',
    figureSkating: 'Figure Skating',
    formula1: 'Formula-1',
    gymnastics: 'Gymnastics',
    hockey: 'Hockey',
    kickboxing: 'Kickboxing',
    motorSports: 'Motor Sports',
    muayThai: 'Muay Thai',
    olympics: 'Olympics',
    poleSports: 'Pole Sports',
    sportsInfluencer: 'Sports Influencer',
    swimming: 'Swimming',
    trackField: 'Track & Field',
    visualArtist: 'Visual Artist',
    wheelchairRugby: 'Wheelchair Rugby',
    wrestling: 'Wrestling',
    iceHockey: 'Ice Hockey',
    alpineSkiing: 'Alpine Skiing',
    flagFootball: 'Flag Football',
    climbing: 'Climbing',
    badminton: 'Badminton',
    motorcycleRacing: 'Motorcycle Racing'
  },
  levels: {
    interested: 'Interested',
    beginner: 'Beginner',
    amateur: 'Amateur',
    intermediate: 'Intermediate',
    expert: 'Expert',
    retired: 'Retired'
  },
  auth: {
    sponsorConsent: 'I agree to receive information from sponsors',
    signUpFacebook: 'Sign up with Facebook',
    signUpGoogle: 'Sign up with Google',
    signUpPaypal: 'Sign up with PayPal',
    forgottenPassword: 'Forgotten your password?',
    logInFacebook: 'Log in with Facebook',
    logInGoogle: 'Log in with Google',
    logInPaypal: 'Log in with PayPal',
    dontHaveAccount: "Don't have an account?",
    mustContain8Characters: 'Must at least contain 8 characters.',
    alreadyHaveAccount: 'Already have an account?',
    passwordReset: 'Password reset',
    resetInstructions:
      "Enter the email associated with your account, and we'll send you the password recovery instructions.",
    sendRecoveryEmail: 'Send recovery email',
    backTo: 'Back to',
    logIn: 'Log in',
    checkEmail: 'Check your email address',
    noAccount: 'There is no account associated',
    pleaseTryAnother: 'Please try another address.',
    tryAnother: 'Try another email',
    emailSent: 'Recovery email sent',
    checkEmailInstructions:
      'Check your inbox (and spam folders) to find and follow the instructions to reset your password.',
    createNewPassword: 'Create new password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    resetPassword: 'Reset password',
    validateYourEmail: 'Validate your email',
    validateEmailInstructions:
      'We need you to validate your email activating your new P4P account.',
    confirmEmail: 'Confirm email',
    validationEmailSent: 'Validation email sent',
    checkInboxToValidateEmail:
      'Check your inbox (and spam folders) to find and follow the instructions to validate your email.',
    getTheApp: 'Get the App',
    accountLocked: 'Your account is locked',
    accountLockedDesc:
      'We keep things secure and have locked your account because of too many attempts with the wrong credentials. Please check your inbox to reset your password.',
    checkInbox: 'Check my inbox',
    youAcceptTerms:
      'By registering or logging in, you agree to our Terms and Conditions and Privacy Policy',
    logInApple: 'Login with Apple',
    signUpApple: 'Sign up with Apple',
    invalidEmail: 'Invalid email format.',
    promptAuthMsg: 'You need to create an account to perform this action.'
  },
  messages: {
    newMessages: 'New messages',
    newGroup: 'New Group',
    favorites: 'Favorites',
    favoritesAtTop: 'Favorites at the top',
    favoritesOnly: 'Favorites only',
    excludeHidden: 'Exclude hidden',
    showHidden: 'Show hidden',
    hiddenChats: 'Hidden chats',
    message: 'Message',
    addChat: 'Add chat',
    searchFriends: 'Search friends',
    createdGroup: '{{group}} created this group',
    totalMessageSingular: '1 New message',
    totalMessages: '{{totalMessageCount}} New messages',
    noChats: 'No chats available.',
    noChatSelected: 'No chat selected.',
    messageDotDotDot: 'Message...',
    noChatYet: 'No chat here yet...',
    searchFriendsGroups: 'Search friends or groups...',
    selectFriend: 'Select Friend',
    groupChatName: 'Group chat name',
    startChat: 'Start chat',
    youNeedSub: 'You need to subscribe to {{name}} to send a message',
    youBlocked: 'You blocked this user'
  },
  home: {
    latestPosts: 'Latest Posts',
    confirmed: 'Confirmed',
    playazRunsSafeEnvironment: 'Playaz runs a safe environment',
    connectionsConverstationsFollowedAthletes:
      'Like-minded connections to have conversations, group meetups, and learning from your followed athletes.',
    myPosts: 'My posts',
    accountsToFollow: 'Accounts to follow',
    comingUp: 'Coming up',
    gloriousWinners: 'Glorious winners',
    todaysGames: "Today's Games",
    athleteHighlights: 'Highlights',
    fanHighlights: 'Highlights',
    todaysMatches: "Today's Matches"
  },
  add: {
    followers: 'Followers',
    subscribers: 'Subscribers',
    onlyMe: 'Only me',
    photoVideo: 'Photos/Videos',
    tag: 'Tag',
    editMedia: 'Edit media',
    tapCrop: 'Tap on an image to crop.',
    gallery: 'Gallery',
    addMultiple: 'Add multiple',
    shoutOutTo: 'Shout out to',
    whereItHappens: 'Where it happens',
    shouldAcceptTerms: 'You need to accept Terms & Conditions',
    summary: 'Summary',
    total: 'Total',
    iAcceptTerms:
      'As per the terms & conditions, I accept to be charged the amount stated above upon the athlete confirmation',
    post: 'Post',
    enterYoutubeLink: 'Enter Youtube link',
    tagFriends: 'Tag friends',
    shareWith: 'Share with',
    everyone: 'Everyone',
    peopleFollowBack: 'Only people I follow back',
    linkToVideo: 'Link to video',
    swipeRightPurchase: 'Swipe right to purchase',
    uploadMedia: 'Upload media',
    shareLink: 'Share link',
    correctYoutubeLink: 'Please add a correct Youtube link.',
    writeCaption: 'Write a caption',
    selectionsWillRemove:
      'You can only post a single video, other selections will be removed. Proceed?',
    selectVideo: 'Select video',
    onlySingleVideo: 'You can only post a single video for now.',
    upToAMinutes: 'Max video length of 1 minute is allowed.',
    text: 'Text',
    video: 'Video',
    tagPeople: 'Tag people',
    enterLink: 'Enter link',
    linkToOriginalPost: 'Link to original post',
    pasteForPreview: 'Paste the link to see the post preview',
    createPost: 'Create post',
    recent: 'Recent',
    noUserFound: 'No users found with the matching criteria',
    searchResults: 'Search results',
    storyPublished: 'Story published!',
    live: 'Live',
    shoutout: 'Shoutout',
    addPhotosAndVideos: 'Add photos & videos',
    addLocation: 'Add location',
    onlyForSubscribers: 'Only for subscribers',
    photosAndVideos: 'Photos & videos',
    selectUpTo10: 'Select up to 10',
    suggested: 'Suggested',
    shoutoutTo: 'Shoutout to',
    createShoutout: 'Create shoutout',
    newShoutout: 'New Shoutout',
    tapOrHold: 'Tap for photo, hold for video',
    tapGoLive: 'Tap to go live',
    addNewPost: 'Add new post',
    addNewShoutout: 'Add new shoutout',
    fileFormats: 'JPEG, PNG, MP4, WebM, or Ogg file formats',
    create: 'Create',
    correctLink: 'Please add a correct link.',
    addShoutout: 'Add shoutout',
    teamOrPlayer: 'Team or player',
    team: 'Team',
    startStreaming: 'Start streaming',
    createNewShoutout: 'Create New Shoutout',
    createNewPost: 'Create New Post',
    selectFile: 'Select file'
  },
  browse: {
    trySearchAthlete: 'Try searching for an athlete, team, or a hashtag',
    basedYourPreferences:
      'Based on your preferences, here are some athletes and fans you might enjoy following.',
    erlingHaaland: 'Erling Haaland',
    parisSaintGermain: 'Paris Saint-Germain',
    trendingPosts: 'Trending Posts',
    chooseSportAndFavoriteTeam:
      'Choose sports and pick your favorite team of athletes to keep you updated.',
    trendingTeams: 'Trending Teams',
    seeTeamsYourFellow: 'See teams your fellow fans and athletes are following right now.',
    atalanta: 'Atalanta',
    serieaFootballClub: 'Serie A Football club',
    browse: 'Browse',
    athletesOnPlatform: 'Athletes on P4P',
    fansOnPlatform: 'Fans on P4P',
    upcomingEvents: 'Upcoming Events',
    eventsComingUpYourFavorite:
      'Events coming up based on your favorite sports, teams, and athletes.',
    superBantamweight: 'Super Bantamweight',
    tiffanyVanSoestAlinePereira: 'Tiffany van Soest - Aline Pereira',
    chicagoVenue: 'Chicago, Chicago Venue',
    suggestedAthletes: 'Suggested athletes',
    suggestedFans: 'Suggested fans',
    suggestedAccounts: 'Suggested Accounts',
    newAppHasArrived: 'Our new app has arrived!',
    newAppDesc:
      'We have enriched your P4P experience with your feedback. Enjoy the updated APP and stay tuned for further updates.',
    seeTheApp: 'See the APP',
    postCountSingular: '1 post',
    postCountPlural: '{{count}} posts',
    recent: 'Recent',
    top: 'Top',
    athletes: 'Athletes',
    teams: 'Teams',
    tags: 'Tags',
    fans: 'Fans',
    trendingShoutouts: 'Trending shoutouts',
    goBrowse: 'Go browse',
    follower: 'follower',
    followers: 'followers',
    todaysGames: "Today's Games",
    trendingAthletes: 'Trending Athletes',
    trendingFans: 'Trending Fans',
    allAthletes: 'All Athletes',
    allFans: 'All Fans',
    sortBy: 'Sort by',
    name: 'Name',
    popularity: 'Popularity',
    recentlyRegistered: 'Recently registered',
    filterByConnection: 'Filter by connection',
    showAll: 'Show all',
    showOnlyConnect: 'Show only athletes you can connect',
    teamsOnPlatform: 'Teams on P4P',
    allTeams: 'All Teams',
    todaysMatches: "Today's Matches"
  },
  chat: {
    muteNotifications: 'Mute Notifications',
    removeFavorites: 'Remove from favorites',
    addFavorites: 'Add to favorites',
    clearChatHistory: 'Clear chat history',
    youCannotAction: 'You cannot undo this action.',
    deleteConversationWith: 'Delete conversation with ',
    deleteConversation: 'Delete Conversation',
    unhideChat: 'Unhide chat',
    hideChat: 'Hide chat',
    clearHistory: 'Clear history',
    noResults: 'No results...',
    noMessagesYet: 'No messages here yet...',
    returnChat: 'Return to chat',
    searchMessages: 'Search messages...',
    clearConfirmation: 'Are you sure you want to clear this chat?',
    deleteConfirmation: 'Are you sure you want to delete this chat?',
    block: 'Block',
    disableSound: 'Disable Sound',
    muteNotificationsFor: 'Mute notifications for...',
    thirtyMinutes: '30 minutes',
    oneHour: '1 hour',
    oneDay: '1 day',
    oneWeek: '1 week',
    oneMonth: '1 month',
    muteForever: 'Mute forever'
  },
  comments: {
    succesfullyReactedPost: 'Successfully reacted to this post.',
    beFirstReaction: 'Be the first to react',
    comments: 'Comments',
    noComments: 'No comments',
    comment: 'Comment'
  },
  connect: {
    endOneOnOneWith: 'End Face2Face with ',
    youWontGoBackCall: "You won't be able to go back to this paid call.",
    sayGoodBye: 'Say good bye to ',
    timeToWrapUp: 'Time to wrap up',
    oneOnOneCall: 'Face2Face call',
    setupConnect: 'Setup Face2Face'
  },
  connectConfirmations: {
    cancelOneOnOne: 'Cancel Face2Face',
    unfortunatelyCanceled:
      'Unfortunately your Face2Face with <strong>{{name}}</strong> has been canceled.',
    timeToStart:
      "It's time to start your booked <strong>15 minutes</strong> Face2Face with <strong>{{name}}</strong>",
    swipeCancel: 'Swipe right to cancel connect',
    wantCancelOneOnOne: 'Do you want to cancel the Face2Face with <strong>{{name}}</strong>?',
    youWillPay:
      "This can't be undone and you will pay a <strong>50% cancellation fee</strong> ({{amount}})",
    fanWillGet: "This can't be undone and fan will get a <strong>100% refund</strong> ({{amount}})",
    swipeRightStart: 'Swipe right to start connect',
    oneOnOneConnectEnded: 'Face2Face ended',
    '15minCall': 'Your 15 minutes call with {{name}}, and we hope you had an exciting conversation',
    bookAnotherOneOnOne: 'Book another Face2Face',
    refuseOneOnOne: 'Refuse Face2Face',
    wantRefuseOneOnOne: 'Do you want to refuse the Face2Face with {{name}}',
    swipeRightRefuseConnect: 'Swipe right to refuse connect',
    '15minCallWithAthlete':
      'Your 15 minutes call with {{name}}, and we hope you had an exciting conversation with your favorite athlete.',
    waitingInLobby: 'Waiting in the lobby...',
    pleaseWaitUser: 'Please wait for your Face2Face with <strong>{{name}}</strong> to start.',
    refusedOneOnOneConnect: 'Refused Face2Face',
    callSettings: 'Call settings:'
  },
  settings: {
    referAnAthlete: 'Refer an athlete',
    upgradePlan: 'Upgrade plan',
    settings: 'Settings',
    changePassword: 'Change Password',
    oldPassword: 'Old password',
    newPassword: 'New password',
    privacyAndSecurity: 'Privacy & Security',
    profilePrivacySettings: 'Profile Privacy Settings',
    whoCanView: 'Who can view your profile page?',
    whoCanViewInfo: 'Who can view the info tab on your profile page?',
    whoCanViewBasicInfo: 'Who can view your basic info?',
    whoCanViewLocation: 'Who can view your location?',
    whoCanViewActivities: 'Who can view your activities section on your profile page?',
    whoCanShare: 'Who can share a post on your wall?',
    whoCanViewFriends: "Who can view your friend's list?",
    whoCanSendFriends: 'Who can send me a friend request?',
    whoCanSendMessage: 'Who can send you a message?',
    whoCanViewPhotos: 'Who can view photos on your profile page?',
    whoCanPokes: 'Who can send pokes?',
    whoCanViewViewed: 'Who can view who recently viewed your profile?',
    whoCanTag: 'Who can tag me in written contexts?',
    whoCanSeeDateOfBirth: 'Who can see your Date of Birth?',
    allowSharing: 'Allow sharing from',
    allowMentions: 'Allow mentions from',
    allowTags: 'Allow tags from',
    avilabilityPeriod: 'Availability period',
    pleaseShare:
      "Please share your monthly revenue expectations. Fans won't see this in your profile.",
    customPeriod: 'Custom period...',
    from: 'From',
    to: 'To',
    selectStart: 'Select start date',
    selectEnd: 'Select end date',
    total: 'Total',
    pendingRequest: 'Pending requests',
    invalid: 'invalid',
    today: 'Today',
    months: 'Months',
    weeks: 'Weeks',
    setAvailability: 'Set availability',
    fansWillOnly: 'Fans will only be able to book a Face2Face within the available slots',
    period: 'Period',
    dayOfTheWeek: 'Day of the week',
    daily: 'Daily',
    thisWeek: 'This week',
    thisMonth: 'This month',
    availableTime: 'Available time',
    time: 'Time',
    timeBetween: 'Time between connects',
    breakDuration: 'Break duration',
    setAvailableTime: 'Set available time from',
    chooseATime: 'Choose a time during the day when you want to get Face2Face requests from',
    weekDays: 'Week days',
    weekends: 'Weekends',
    oneOnOneConnect: 'Face2Face',
    save: 'Save',
    search: 'Search',
    subscriptions: 'Subscriptions',
    emailNotifications: 'Email notifications',
    languageAndCurrency: 'Language & Currency',
    theme: 'Theme',
    billing: 'Billing',
    billingSubscription: 'Billing & Subscriptions',
    accessBilling: 'Access billing information',
    logOut: 'Log out',
    countryCode: 'Country code',
    selectCountry: 'Select country',
    passwordChangeSuccessful: 'You have successfully updated your password.',
    confirmNewPassword: 'Confirm new password',
    forgotPassword: 'Forgot password?',
    enableEmailNotifications: 'Enable email notifications',
    newComments: 'New comments',
    newTags: 'newTags',
    newSubscriptions: 'New subscriptions',
    newFriends: 'New friends',
    friendRequests: 'Friend requests',
    notificationForLikes: 'Notification for "Likes"',
    newMessages: 'New messages',
    photosNotifications: 'Photos notifications',
    language: 'Language',
    currency: 'Currency',
    anyone: 'Anyone',
    community: 'Community',
    friendsOnly: 'Friends only',
    noOne: 'No one',
    onlyAvailableViaApp: 'Only available via mobile APP',
    darkMode: 'Dark Mode',
    contentPrivacySettings: 'Content Privacy Settings',
    setAvailableTimeTo: 'Set available time to',
    chooseATimeTo: 'Choose a time during the day when you want to get Face2Face requests to',
    removeAccount: 'Remove account',
    accountPrivacy: 'Account',
    contactUs: 'Contact us',
    leaveMessage: 'Leave us a message',
    howCanWeHelp: 'How can we help you?',
    stripeConnect: {
      title: 'Stripe Connect',
      description:
        'Connect your Stripe account to receive subscription revenue splits automatically.',
      checkingStatus: 'Checking connection status...',
      connected: 'Connected',
      notConnected: 'Not connected',
      notConnectedDesc:
        "Subscription revenue splits won't be applied until you connect a Stripe account.",
      chargesEnabled: 'Charges enabled',
      chargesDisabled: 'Charges disabled',
      payoutsEnabled: 'Payouts enabled',
      payoutsDisabled: 'Payouts disabled',
      disconnectHint: 'To disconnect your Stripe account, please contact admin.',
      connectButton: 'Connect Stripe Account',
      connecting: 'Redirecting...',
      connectSuccess: 'Stripe account connected successfully!',
      errorInvalidTeam: 'Invalid team ID in OAuth callback.',
      errorNoAccountId: 'No Stripe account returned from OAuth.',
      errorTeamNotFound: 'Team not found during OAuth callback.',
      errorOAuthFailed: 'Stripe OAuth failed. Please try again.',
      errorGeneric: 'Stripe connect failed. Please try again.',
      errorInitFailed: 'Failed to initiate Stripe Connect. Please try again.',
      errorNoUrl: 'Could not get Stripe OAuth URL. Please try again.',
      requestReplacement: 'Request Account Replacement',
      requestDeletion: 'Request Disconnection',
      requestReplacementTitle: 'Request Stripe Account Replacement',
      requestDeletionTitle: 'Request Stripe Account Disconnection',
      requestReplacementPlaceholder:
        'Describe why you need to replace your Stripe account (e.g. legal entity change, ownership update)...',
      requestDeletionPlaceholder: 'Describe why you need to disconnect your Stripe account...',
      replacementPending: 'Replacement Requested — Pending Admin Approval',
      deletionPending: 'Disconnection Requested — Pending Admin Approval',
      replacementRequested: 'Replacement request submitted. An admin will review it shortly.',
      deletionRequested: 'Disconnection request submitted. An admin will review it shortly.',
      replaceSuccess: 'Stripe account replaced successfully!',
      errorInvalidReplacementToken: 'The replacement link is invalid or has already been used.',
      errorReplacementTokenExpired: 'The replacement link has expired. Please request a new one.',
      errorRegionNotSupported:
        'This Stripe account cannot receive payments from your region. Please connect an account in the same region as the platform.'
    }
  },
  scheduleConnect: {
    '15minutesCall': '15 minutes call',
    thereIsNo: 'There is no availability for this date.',
    selectTime: 'Select time',
    bookOneOnOne: 'Book Face2Face',
    youAlreadyHave: 'You already have a connect with this athlete.',
    scheduleAlreadyExist: 'Schedule Already Exists',
    ad: 'AD',
    nextAvailableSlot: 'Next available slot',
    noScheduleFound: 'No schedule found',
    thisUserHasnt: "This user hasn't set their schedule yet. Please come back later.",
    schedule: 'Schedule',
    today: 'Today',
    tomorrow: 'Tomorrow',
    weeks: 'Weeks',
    seeCalendar: 'See calendar',
    dateAndTime: 'Date and time',
    edit: 'Edit',
    total: 'Total:',
    asPerTheTerms:
      'As per the terms & conditions, I accept to be charged the amount stated above upon the athlete confirmation',
    sendRequest: 'Send request',
    oneOnOneRequest: 'Face2Face request sent',
    afterTheAthleteAccepts:
      'After the athlete accepts your request, you will receive the notification and see the pending Face2Face on the dashboard.',
    goToDashboard: 'Go to dashboard',
    bookOtherOneOnOne: 'Book other Face2Face',
    proceed: 'Proceed',
    searcAthletes: 'Search athletes',
    notVerified: 'This profile is not a verified athlete.',
    bookOneOnOneTeam: 'Booking a Face2Face? Please select your favorite athlete. Thank you!',
    noBooked: "You don't have booked Face2Face yet",
    bookedYet: 'Have you booked a Face2Face yet?',
    selectDay: 'Select day',
    nextOneOnOnes: 'Next Face2Face',
    noResults:
      'All our athletes have a packed schedule. Availabilities do open regularly so please come back later.'
  },
  connectsDashboard: {
    byFan: 'BY FAN',
    byAthlete: 'BY ATHLETE',
    pending: 'Pending',
    confirmed: 'Confirmed',
    rejected: 'Rejected',
    timeBooked: 'Time booked',
    refuseOneOnOneConnect: 'Refuse all Face2Face for ',
    refuseAll: 'Refuse all',
    oneOnOneConnect: 'Face2Face',
    bookAgain: 'Book again'
  },
  dashboard: {
    monthlyTarget: 'Monthly target',
    setMonthlyRevenueTarget: "You haven't set your monthly revenue target yet.",
    useAthleteRefferalCodes: 'Use athlete referral codes to grow the team',
    setupRateAndAvailability: 'Setup rate and availability to get Face2Face requests.',
    shoutouts: 'Shoutouts',
    vipConnect: 'VIP Connect',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    all: 'All',
    custom: 'Custom...',
    total: 'Total',
    dashboard: 'Dashboard',
    referrals: 'Referrals',
    income: 'Income',
    users: 'Users',
    subscribed: 'Subscribed',
    progress: 'Progress',
    followers: 'Followers',
    advertising: 'Advertising',
    views: 'Views',
    number: 'Number',
    athleteEmail: 'Athlete email',
    meetings: 'Meetings',
    itemsSold: 'Items Sold',
    store: 'Store',
    editMonthlyTarget: 'Edit monthly target',
    inviteToGrow: 'Type email to send an invitation to grow the team.',
    inviteAthletes: 'Invite athletes',
    follower: 'Followers'
  },
  editProfile: {
    sport: 'Sport',
    selectSuport: 'Select Sport',
    favoriteTeam: 'Favorite Team',
    selectTeam: 'Select Team',
    favoritePlayer: 'Favorite Player',
    selectPlayer: 'Select Player',
    addMoreSport: 'Add more sport',
    editProfile: 'Edit Profile',
    dateOfBirth: 'Date of Birth',
    bio: 'Bio',
    mySport: 'My sport',
    mySports: 'My sports',
    position: 'Position',
    selectPosition: 'Select Position',
    level: 'Level',
    selectLevel: 'Select Level',
    personalInformation: 'Personal Information',
    myGender: 'My gender',
    female: 'Female',
    male: 'Male',
    other: 'Other',
    imFrom: "I'm from",
    yourPhoneNumber: 'Your Phone Number'
  },
  profile: {
    wantToConnect: 'Want to get in touch face-to-face?',
    favoriteSports: 'Favorite Sports',
    favoriteAthlete: 'Favorite Athlete',
    referAndReward: 'Get rewarded by referring an athlete',
    invitePeople: 'Invite people',
    earnMoreReferralFees: 'Earn more referral fees by inviting athletes around you',
    inviteAthleteFan: 'Invite Athletes and Fans',
    typeEmailToInvite: 'Type email to send an invitation to grow the team.',
    athleteEmail: 'Athlete email',
    doesntExists: "This user doesn't exist.",
    shoutouts: 'Shoutouts',
    mySports: 'My Sports',
    myEquipment: 'My equipment',
    relatedProducts: 'Related Products',
    bidForEquipment: 'Bid for my equipment',
    goToAppSettings: 'Go to APP settings',
    followRequired: 'You need to follow {{teamName}} before you can use {{feature}}.',
    recentShoutouts: 'Recent Shoutouts',
    recentUpdates: 'Recent Updates',
    trendingPosts: 'Trending Posts',
    following: 'Following',
    userNotFound: 'User @{{username}} not found',
    searchFriendsAndFollowers: 'Search friends and followers',
    noUpdatesYet: 'Exciting new things coming soon...',
    noPostsYet: '{{name}} has not posted yet',
    followToKnowFirst:
      'Follow {{name}} to be the first who knows about updates like podcasts or live streaming.',
    encourage: 'Feel free to send them a shout-out to encourage them.',
    threeMonthsAccess: 'You have three months of unlimited closed door access',
    enjoyFreeAccess: 'Enjoy the exclusive content from the athletes.',
    repostHeader: '<strong>{{owner}}</strong> shared <strong>{{originalOwner}}</strong> post',
    nowFollowing: 'Now following {{name}}',
    sureToRemove: 'Are you sure you want to remove your account? This action is irreversible.',
    getUnlimited: 'Get unlimited access',
    getUnlimitedDesc: 'Subscribe to your favorite athlete to get all access.',
    verifiedAthlete: 'Verified athlete',
    callToAction: 'Call-to-Action Share',
    mediaShare: 'Media Share',
    selectEngagement: 'Select engagement',
    writeCaption: 'Write a caption',
    engagement: 'Engagement'
  },
  notifications: {
    notifications: 'Notifications',
    noNotificationsTitle: 'No notifications yet',
    noNotifications: "You're all caught up — new notifications will show up here.",
    comingUpConnect: 'Coming up Face2Face with <strong>{{sender}}</strong> in five minutes',
    connectRequest: 'Face2Face request from <strong>{{sender}}</strong>',
    connectStatus: '{{status}} Face2Face with <strong>{{sender}}</strong>',
    connectStarting:
      "It's time to start your booked <strong>15 minutes</strong> Face2Face with <strong>{{sender}}</strong>",
    commentedToPost: '<strong>{{sender}}</strong> \ncommented on your post',
    commentedToSportChat: '<strong>{{sender}}</strong> \ncommented on your sport chat',
    reactedToPost: '<strong>{{sender}}</strong> \nreacted to your post',
    reactedToShoutout: '<strong>{{sender}}</strong> \nreacted to your shoutout',
    amountReactedToPost: '{{amount}} people reacted to your post',
    aNewShoutout: 'You have <strong>a new shoutout</strong>',
    newShoutouts: 'You have <strong>{{amount}} new shout-outs</strong>',
    shoutoutReaction: '{{sender}} reacted to your shoutout',
    startedFollowing: '<strong>{{sender}}</strong> \nstarted following you',
    amountStartedFollowing: '{{amount}} users started following you',
    newSub: 'You have a new subscriber',
    newSubs: 'You have {{amount}} new subscribers',
    newRequests: '{{amount}} new Face2Face requests',
    newFollower: 'followed you',
    taggedInPost: '<strong>{{sender}}</strong> \ntagged you in their post',
    mentionedInPost: '<strong>{{sender}}</strong> \nmentioned you in their post',
    commentTagged: '<strong>{{sender}}</strong> \ntagged you in their comment',
    p4pMonetizingYourBrand: 'P4P is Monetizing Your Brand!',
    fanRequestingShoutout: 'A Fan is Requesting a Shoutout.',
    view: 'View',
    congratulations: 'Congratulations!',
    yourFavoriteAthleteCompletedYourRequest: 'Your favorite athlete has completed your shoutout.',
    sorryFavoriteAthleteCurrentlyUnavailable:
      'Sorry your favorite athlete is currently unavailable. Please try again later or select another player.',
    sender: '<strong>{{sender}}</strong>',
    sportChatCommentTagged: '<strong>{{sender}}</strong> \ntagged you in their sport chat comment',
    startedSubscribing: '<strong>{{sender}}</strong> \nis now subscribed to you',
    contentRemoved:
      'Your <strong>{{content}}</strong> was removed for violating our community guidelines ({{reason}})',
    contentRemovedNoReason:
      'Your <strong>{{content}}</strong> was removed for violating our community guidelines',
    contentWarned:
      'Your <strong>{{content}}</strong> was published, but it may violate our community guidelines ({{reason}})',
    contentWarnedNoReason:
      'Your <strong>{{content}}</strong> was published, but it may violate our community guidelines',
    moderatedContent: {
      post: 'post',
      comment: 'comment',
      fanChat: 'chat post',
      shoutout: 'shoutout',
      fanCamPhoto: 'FanCam photo',
      story: 'story',
      profileDescription: 'profile bio',
      username: 'username',
      profileImage: 'profile photo',
      content: 'content'
    }
  },
  repost: {
    tagFriends: 'Tag friends',
    repost: 'Repost',
    create: 'Create',
    yourComment: 'Your comment',
    shareWith: 'Share with',
    everyone: 'Everyone',
    OnlyPeopleIFollowBack: 'Only people I follow back'
  },
  onBoarding: {
    everybody: 'EVERYBODY',
    plays: 'PLAYS',
    better: 'BETTER',
    together: 'TOGETHER.',
    favoriteSports: 'Favorite sports',
    chooseSports: 'Choose sports and pick your favorite team of athletes to keep you updated.',
    selectSport: 'Select sport',
    sport: 'Sport',
    favoriteTeam: 'Favorite Team',
    selectTeam: 'Select Team',
    favoritePlayer: 'Favorite Player',
    selectPlayer: 'Select Player',
    addMoreSport: 'Add more sport',
    getStarted: 'Get started',
    youreAlmostThere: "You're almost there",
    tellUsAboutYourself: 'Tell us about yourself to get the most relevant feeds and updates.',
    imFrom: "I'm from",
    yourPhoneNumber: 'Your Phone Number',
    dateOfBirth: 'Date of birth',
    monthlyRevenueTarget: 'Monthly Revenue Target',
    pleaseShareYour:
      "Please share your monthly revenue expectations. Fans won't see this in your profile.",
    next: 'Next',
    skipThisStep: 'Skip this step',
    yourSports: 'Your sports',
    chooseASport: 'Choose a sport and pick your position.',
    mySport: 'My sport',
    position: 'Position',
    selectPosition: 'Select Position',
    addSecondarySport: 'Add secondary sport',
    chooseSportsYou: 'Choose sports you are interested in.',
    skipAndGet: 'Skip and get started',
    connectDirectlyWith: 'Connect directly with your favorite athletes and other fans.',
    monetizeYourBrand: 'Monetize your brand by creating a unique world with your fans.',
    chooseAUsername: 'Choose a Username',
    referralCodeOptional: 'Referral code (optional)',
    backTo: 'Back to',
    logIn: 'Log in',
    imAFan: "I'm a fan",
    imAnAthlete: "I'm an athlete",
    createAnAccount: 'Create an account',
    searchTeams: 'Search teams'
  },
  shoutout: {
    comingSoon: 'Shoutout is coming soon',
    comingSoonDesc:
      'Communicate with famous athletes worldwide, sending motivating and celebrating shoutouts.',
    success: 'Shoutout sent successfully.',
    selectTeamOrAthete: 'Select a Team or Athlete',
    teamOrAthlete: 'Team/Athlete',
    writeShoutout: 'Write a shoutout',
    createMatchDayShoutout: 'Create Match Day Shoutout',
    matchDayShoutouts: 'Match Day Shoutouts',
    shoutoutsFromAthletes: 'From Athletes',
    shoutoutsFromFans: 'From Fans',
    sentShoutout: 'Shoutout sent!',
    shoutoutusage: "You've used {{used}} of {{limit}} available Shoutouts this week."
  },
  shop: {
    comingSoon: 'Store is coming soon',
    comingSoonDesc:
      "Merchandise from your favorite famous athletes, tickets to events, exclusive offers, and more will be available via our cozy store. We'll notify you about the opening soon."
  },
  header: {
    logOutConfirmation: 'Log out from your account? You can log in later using your credentials.',
    upgradePlan: 'Upgrade plan'
  },
  post: {
    timestampYear: 'y',
    timestampMonth: 'm',
    timestampWeek: 'w',
    timestampDays: 'd',
    timestampHour: 'h',
    timestampSecond: 's',
    deletePost: 'Delete post',
    editPost: 'Edit post',
    reportPost: 'Report post',
    areYouSure: 'Are you sure you want to delete your post?',
    reportingSoon: 'Reporting is not available yet. Please come back later.',
    beingProcessed: 'This video is being processed, please come back later.'
  },
  billing: {
    billing: 'Billing',
    settings: 'Settings',
    history: 'History',
    billingInformation: 'Billing information',
    paymentMethod: 'Payment method',
    addPaymentMethod: 'Add payment method',
    youNeedToAddMethod: 'You need to add a payment method.',
    forYourPurches: 'You will be redirected to our web app in order to add your payment method.',
    goToWebApp: 'Got to web app',
    exp: 'Exp',
    removingCard: 'This card will be removed',
    sureToRemove: 'Are you sure you want to remove **** {{last4}}?',
    noPaymentsYet: 'No payments yet',
    processedPaymentsHere: 'Here you’ll see the list of the processed payments.',
    shoutoutTo: 'Shoutout to {{name}}',
    connectWith: 'Face2Face with {{name}}',
    connectRefused: 'Face2Face refused by {{name}}',
    connectCanceledBy: 'Face2Face canceled by {{name}}',
    termsAndConditions:
      'As per the terms & conditions, I accept to be charged the amount stated above upon the p4p confirmation',
    swipeRightToPurchase: 'Swipe right to purchase',
    subscription: 'Subscribe to {{name}}',
    productOrder: 'Product Order',
    purchase: 'Purchase',
    noActiveSubscription: 'No active subscription',
    subscribeToUnlock: 'Subscribe to a plan to unlock exclusive content and features.',
    activeSubscriptionCount: '{{count}} active subscription',
    activeSubscriptionCount_plural: '{{count}} active subscriptions',
    noSubscriptionsInFilter: 'No subscriptions match this filter.',
    amount: 'Amount',
    cycle: 'Cycle',
    nextPayment: 'Next payment',
    payment: 'Payment',
    details: 'Details',
    viewDetails: 'View details',
    expiresToday: 'Expires today',
    expiresInDays: 'Expires in {{count}} days',
    billingCycle: 'Billing cycle',
    started: 'Started',
    currentPeriod: 'Current period',
    renewals: 'Renewals',
    provider: 'Provider',
    includedFeatures: 'Included features',
    recentActivity: 'Recent activity',
    downloadInvoice: 'Download Invoice',
    goBack: 'Go Back',
    cancelSubscription: 'Cancel subscription',
    scheduledForCancellation:
      'Subscription cancelled. You will retain access until the end of your current billing period.',
    cancelConfirmation:
      "Are you sure you want to cancel your {{plan}} subscription for {{team}}? You'll continue to have access until {{date}}.",
    cancelReasonLabel: 'Reason for cancellation (optional)',
    cancelReasonPlaceholder: "Tell us why you're cancelling...",
    requestRefund: 'Request refund',
    refundPending: 'Refund Requested — Pending Approval',
    refundApproved: 'Refund Approved',
    refundRejected: 'Refund Rejected',
    refundPendingMessage:
      'Your request is under review. We will update this status after admin action.',
    refundApprovedMessage:
      'Your refund has been approved and is being returned to your original payment method.',
    refundRejectedMessage: 'Your refund request was reviewed and rejected.',
    refundRequestPromptTitle: 'Need a refund?',
    refundRequestPromptDesc:
      'If your payment was collected but subscription activation failed, you can request a refund for admin review.',
    requestedOn: 'Requested on',
    processedOn: 'Processed on',
    refundReference: 'Reference',
    yourNote: 'Your note',
    adminMessage: 'Admin message',
    upgradeSubscription: 'Upgrade Subscription',
    teamSubscription: 'Team Subscription',
    updatePaymentMethod: 'Payment failed. Please update your payment method to continue.',
    updatePaymentDetails: 'Update Payment Details',
    paymentUpdatedTitle: 'Payment method updated',
    paymentUpdatedMessage:
      'Your new card has been saved. Payment will be retried automatically within 24 hours.',
    contactSupport: 'Contact support for help.',
    status_active: 'Active',
    status_pending: 'Pending',
    status_retrying: 'Retrying',
    status_suspended: 'Suspended',
    status_cancelled: 'Cancelled',
    status_failed: 'Failed',
    status_refunded: 'Refunded',
    pendingPaymentAction:
      'Complete your payment at the convenience store to activate your subscription.',
    event_subscribed: 'Subscribed',
    event_renewed: 'Renewed',
    event_upgraded: 'Upgraded',
    pointsEarned: '{{multiplier}} x Points Earned',
    eventUpgradedTo: 'Upgraded to {{plan}}',
    eventUpgradedToInterval: 'Upgraded to {{plan}} ({{interval}})',
    eventChangedTo: 'Changed to {{plan}}',
    eventChangedToInterval: 'Changed to {{plan}} ({{interval}})',
    interval_monthly: 'monthly',
    interval_yearly: 'yearly',
    timeline: {
      totalPaid: 'Total paid',
      currentPlan: 'Current plan',
      nextCharge: 'Next charge',
      noFurtherCharge: 'No further charge',
      nextChargeOn: '{{amount}} on {{date}}',
      refunded: 'Refunded',
      planWithInterval: '{{plan}} ({{interval}})',
      subscribed: 'Subscribed to {{plan}} ({{interval}})',
      subscribedPlain: 'Subscribed to {{plan}}',
      planOnly: '{{plan}}',
      switchedInterval: 'Switched {{plan}} to {{interval}} billing',
      upgradedTo: 'Upgraded to {{plan}} ({{interval}})',
      changedTo: 'Changed to {{plan}} ({{interval}})',
      renewed: 'Renewed {{plan}} ({{interval}})',
      payment: 'Payment',
      paymentFailed: 'Payment failed',
      suspended: 'Subscription suspended',
      cancelled: 'Subscription cancelled',
      refundRequested: 'Refund requested',
      refundApproved: 'Refund approved',
      refundRejected: 'Refund rejected',
      covers: 'Covers {{from}} – {{to}}',
      details: 'Details',
      hideDetails: 'Hide details',
      lineCredit: 'Unused time on your previous plan, credited',
      lineProration: 'Adjustment for the plan change',
      reconcileMatches: 'The timeline matches Stripe: {{amount}} collected.',
      reconcileDiffers: 'The timeline does not match Stripe. It shows {{entries}}; Stripe collected {{stripe}}.',
      reconcileMissingHere: 'Invoices Stripe has that this timeline lacks: {{ids}}',
      reconcileMissingStripe: 'Invoices here that Stripe does not list as paid: {{ids}}',
      reconcileUnavailable: 'This could not be checked against Stripe right now.',
      systemEvents: 'System events ({{count}})',
      status: {
        paid: 'Paid',
        noCharge: 'No charge',
        failed: 'Failed',
        refunded: 'Refunded',
      },
      admin: {
        invoice: 'Invoice',
        stripeFee: 'Stripe fee',
        platformShare: 'Platform share',
        teamTransfer: 'Team transfer',
        providerEvent: 'Provider event',
        unverified: 'Not yet verified',
      },
    },
    event_downgraded: 'Downgraded',
    event_payment_succeeded: 'Payment succeeded',
    event_payment_failed: 'Payment failed',
    event_cancelled: 'Cancelled',
    event_renewal_failed: 'Renewal Failed',
    event_refund_requested: 'Refund requested',
    event_refund_approved: 'Refund approved',
    event_refund_rejected: 'Refund rejected',
    refundTitle: 'Request a refund',
    refundDescription:
      'Submit a refund request for your {{plan}} subscription ({{team}}). Our team will review your request within 3-5 business days.',
    refundReasonLabel: 'Reason for refund',
    refundReasonPlaceholder: 'Please describe the reason for your refund request...',
    submitRequest: 'Submit request'
  },
  revenueTarget: {
    none: 'None',
    oneThousand: 'Up to $1,000',
    fiveThousand: 'Up to $5,000',
    tenThousand: 'Up to $10,000',
    hundredThousand: 'Up to $100,000',
    oneMillion: 'Up to $1,000,000',
    moreThanMillion: 'More than $1,000,000'
  },
  forgotPassword: {
    recoveryEmailSent: 'Recovery email sent',
    checkYourInbox:
      'Check your inbox (and spam folders) to find and follow the instructions to reset your password.',
    backToLogin: 'Back to Log in',
    backToSettings: 'Back to Settings',
    passwordReset: 'Password reset',
    enterEmail:
      "Enter the email associated with your account, and we'll send you the password recovery instructions.",
    sendRecovery: 'Send recovery email',
    checkEmail: 'Check your email address',
    noAccount: 'There is no account associated',
    anotherAddress: 'Please try another address.',
    tryAnother: 'Try another email',
    createNewPassword: 'Create new Password',
    doesntMatch: "Doesn't match",
    newPassword: 'New Password',
    resetPassword: 'Reset Password',
    passwordRule1: 'The new password should be different from the previous one.',
    passwordRule2: 'At least 8 characters—the more characters, the better.',
    passwordRule3: 'Mixture of both uppercase and lowercase letters.',
    passwordRule4: 'Mixture of letters and numbers.',
    passwordRule5: 'At least one special character, e.g., ! @ # ?'
  },
  p4pDay: {
    // The heading is printed in English on every device, in two tight rows, per the
    // P4P Day typography spec — FC Tokyo signs off on it as a wordmark, not as copy.
    headerLine1: 'P4P Day with',
    headerLine2: 'FC Tokyo',
    opening: 'Opening Playaz4Playaz…',
    notInstalled: 'If the app doesn’t open automatically, download it below.',
    desktop: 'Scan the QR code with your phone, or download the app below to join in.',
    followPrompt: 'Sign in or sign up to follow FC Tokyo and upload your photos and videos.',
    giftTitle: 'P4P Day Gift',
    badgeOfTotal: '#{{badgeNo}} out of {{total}} {{color}} badges',
    giftItemLabel: 'Your gift',
    // Keyed by a slug of the ENGLISH name stored on the campaign ("Key Chain" -> keyChain).
    // A tier the sponsor adds later falls back to printing that English verbatim, so it reads
    // correctly from the moment it is created and translated at the next release.
    giftItems: {
      stickers: 'Stickers',
      keyChain: 'Key Chain',
      pen: 'Pen'
    },
    fanIdLabel: 'Your fan ID',
    showAtBooth: 'Show this screen at the P4P Day booth to collect your gift.',
    noGift:
      'All the gifts had been claimed by the time you joined, so there is no gift to collect — but you are still following the team.',
    notEnrolled: 'You are not part of the P4P Day campaign.'
  },
  getTheApp: {
    header: 'Download the Playaz4Playaz App for your smartphone',
    setupAccount: 'Download the Playaz4Playaz App for your smartphone to setup your account.'
  },
  openApp: {
    title: 'Opening the P4P app…',
    body: 'If the app did not open, tap the button below.',
    open: 'Open the App',
    getIt: "Don't have the app yet? Get it here"
  },
  emailView: {
    title: 'Your P4P email',
    unavailable: 'This link has expired or is not valid.'
  },
  share: {
    repost: 'Repost',
    copyLink: 'Copy link',
    viaMessage: 'Share via message',
    toFb: 'Share to Facebook',
    toInst: 'Share to Instagram',
    toTwit: 'Share to Twitter',
    toWhapp: 'Share to WhatsApp',
    toTelg: 'Share to Telegram',
    viaEmail: 'Share via email',
    fb: 'Facebook',
    ig: 'Instagram',
    shareTo: 'Share to'
  },
  verification: {
    verifyProfile: 'Verify your profile',
    verifyProfile2: 'Verify profile',
    accountNeedsVerification:
      'Your account needs verification. Please take a selfie with your ID next to your face. You can do that later from the Profile.',
    needVerification: 'Your account needs verification to join the Face2Face calls.',
    yourProfileVerified: 'Your profile is verified',
    verificationRequested: 'Verification requested',
    beingVerified:
      "The profile is being verified within 24h. After it's done - you can jump into the Face2Face after payment is processed.",
    profileVerifiedDescription:
      'Thanks for completing the verification. Now you can jump into the scheduled Face2Face.'
  },
  events: {
    shoutouts: 'Shoutouts',
    livescore: 'Livescore',
    pictures: 'Pictures',
    stats: 'Stats',
    noShoutouts: 'No shoutouts yet on this event',
    addShoutout: 'Send one now to be the first one to shoutout!'
  },
  games: {
    ht: 'HT',
    ft: 'FT',
    matchday: 'Matchday {{round}}',
    roundOf16: 'Round of 16',
    quarterFinal: 'Quarter final',
    semiFinal: 'Semi final',
    playOff: 'Play off',
    playoffFinal: 'Playoff final',
    final: 'Final',
    preSeason: 'Pre season',
    playOffSemiFinal: 'Playoff semi final',
    wantToShoutout: 'Want to shoutout?'
  },
  permissions: {
    permissionsBlocked: 'Permissions Blocked',
    goToYourSettings: 'Please go to your settings and enable {{permission}}',
    openSettings: 'Open settings',
    camera: 'Camera',
    microphone: 'Microphone',
    gallery: 'Gallery',
    openCamera: 'Open camera'
  },
  store: {
    suggestedItems: 'Suggested Items',
    liked: 'Liked',
    merchandise: 'Merchandise',
    tickets: 'Tickets',
    fromSubscribed: 'From subscribed athletes',
    productDetails: 'Product details',
    selectSize: 'Select size',
    selectStock: 'Select type',
    seeSizeGuide: 'See size guide',
    currentBid: 'Current bid',
    placeBid: 'Place bid',
    likedProducts: 'Liked products',
    noLiked: 'No liked products yet',
    addToCart: 'Add to cart',
    cart: 'Cart',
    totalCost: 'Total cost: ',
    checkout: 'Checkout',
    orderSuccessful: 'Order Successful',
    size: 'Size',
    price: 'Price',
    proceedToPayment: 'Proceed to payment',
    sizeWithDesc: '{{size}} size',
    clearAll: 'Clear all'
  },
  goLive: {
    onlineCount: '{{onlineCount}} subscribers online',
    onlineCountFan: '{{onlineCount}} followers online',
    watchingCount: '{{watchingCount}} watching',
    youAreLive: 'You are live!',
    streamIsFinished: 'The stream is finished.',
    live: 'LIVE',
    end: 'End',
    comment: 'Comment',
    tapForGoLive: 'Tap for go live'
  },
  subscribe: {
    monthly: 'Monthly',
    annual: 'Annual',
    off: '{{amount}}% OFF',
    upToOff: 'UP TO {{amount}}% OFF',
    athletesAndTeams: 'Athletes and teams',
    subscribeFor: 'Subscribe for <strong>{{amount}}</strong>/month',
    subscriptionSummary: 'Subscription summary',
    introductoryOffer: 'Introductory Offer',
    annualDiscount: 'Pay 10 months for 12 with Annual discount',
    noResults: 'No results found with the matching criteria',
    teamFan: '{{team}} fan?',
    subscribeForTeam: 'Subscribe for the all team athletes from <strong>{{amount}}</strong>/month',
    seeAllAthletes: 'See all {{number}} athletes',
    subscribeModalTitle: 'Subscribe to your favorite athletes and teams',
    subscribeModalDesc:
      'Enjoy the exclusive content from the athletes and teams. Subscribe to the teams getting full player access starting from $5.99.',
    athletesToSubscribe: 'Athletes to subscribe',
    numberAthletes: '{{amount}} athletes',
    cancelSubscription: 'Cancel subscription',
    daysLeftInPeriod: '{{amount}} days left in current period',
    sureToCancel: 'Are you sure you want to cancel your subscription?',
    bundleSquad: '{{name}} squad',
    remindMeLater: 'Remind me later'
  },
  americanFootball: {
    quarterback: 'Quarterback',
    runningBack: 'Running Back',
    wideReceiver: 'Wide Receiver',
    tightEnd: 'Tight End',
    leftGuard: 'Left Guard',
    rightGuard: 'Right Guard',
    center: 'Center',
    leftTackle: 'Left Tackle',
    rightTackle: 'Right Tackle',
    noseTackle: 'Nose Tackle',
    defensiveTackles: 'Defensive Tackles',
    offensiveTackles: 'Offensive Tackles',
    offensiveLineman: 'Offensive Lineman',
    middleLineBacker: 'Middle Line Backer',
    outsideLineBacker: 'Outside Line Backer',
    defensiveBack: 'Defensive Back',
    flanker: 'Flanker',
    splitEnd: 'Split End',
    kicker: 'Kicker',
    punter: 'Punter',
    cornerback: 'Cornerback',
    safety: 'Safety',
    defensiveEnd: 'Defensive End',
    runningBackHalfback: 'Running Back (Halfback)',
    runningBackFullback: 'Running Back (Fullback)'
  },
  baseball: {
    centerFielder: 'Center Fielder',
    pitcher: 'Pitcher',
    catcher: 'Catcher',
    baseman: 'Baseman',
    shortstop: 'Shortstop',
    leftFielder: 'Left Fielder',
    rightFielder: 'Right Fielder',
    firstBaseman: 'First Baseman',
    secondBaseman: 'Second Baseman',
    thirdBaseman: 'Third Baseman',
    designatedHitter: 'Designated Hitter'
  },
  basketball: {
    pointGuard: 'Point Guard',
    shootingGuard: 'Shooting Guard',
    smallForward: 'Small Forward',
    powerForward: 'Power Forward',
    center: 'Center',
    comboGuard: 'Combo Guard',
    wingGuard: 'Wing Guard',
    pointForward: 'Point Forward',
    comboForward: 'Combo Forward'
  },
  cricket: {
    captain: 'Captain',
    wicketkeeper: 'Wicketkeeper',
    slip: 'Slip',
    gully: 'Gully',
    point: 'Point',
    cover: 'Cover',
    thirdMan: 'Third Man',
    fineLeg: 'Fine Leg',
    midWicket: 'Midfielder Wicket',
    midOff: 'Midfielder Off',
    squareLeg: 'Square Leg'
  },
  soccer: {
    goalkeeper: 'Goalkeeper',
    striker: 'Striker',
    centerbackStopper: 'Center-back (stopper)',
    centerbackSweeper: 'Center-back (sweeper)',
    centerbackQuarterBack: 'Center-back (quarter-back)',
    rightFullback: 'Right Full-back',
    leftFullback: 'Left Full-back',
    centerForward: 'Center Forward',
    wingers: 'Wingers',
    leftMid: 'Left Midfielder',
    wideMid: 'Wide Midfielder',
    rightMid: 'Right Midfielder',
    centerMid: 'Center Midfielder',
    attackingMid: 'Attacking Midfielder',
    defensiveMid: 'Defensive Midfielder',
    defensiveMidBallWinner: 'Defensive Midfielder (ball-winner)',
    defensiveMidDeepLyingPlaymaker: 'Defensive Midfielder (deep-lying playmaker)',
    boxToBoxMid: 'Box-to-box Midfielder',
    wingback: 'Winger/Wing-back',
    false9: 'False 9',
    raumdeuter: 'Raumdeuter',
    forward: 'Forward'
  },
  tennis: {
    oneUp: 'One-up',
    oneBack: 'One-Back'
  },
  handball: {
    goalkeeper: 'Goalkeeper',
    leftBack: 'Left Back',
    centerBack: 'Center Back/Center',
    rightBack: 'Right Back',
    leftWinger: 'Left Winger',
    centerForward: 'Center Forward/Pivot/Circle Runner',
    rightWinger: 'Right Winger',
    farRight: 'Far Right',
    halfRight: 'Half Right',
    backCenter: 'Back Center',
    frontCenter: 'Front Center'
  },
  iceHockey: {
    leftDefenseman: 'Left Defenseman',
    goaltender: 'Goaltender/Goalie',
    rightDefenseman: 'Right Defenseman',
    leftWinger: 'Left Winger',
    center: 'Center',
    rightWinger: 'Right Winger'
  },
  lacrosse: {
    attackmen: 'Attackmen',
    mid: 'Midfielder',
    defensemen: 'Defensemen',
    goalkeeper: 'Goalkeeper'
  },
  polo: {
    lowWingLeftWing: 'Low Wing/Left Wing',
    lowWingRightWing: 'Low Wing/Right Wing',
    centerHoleSet: 'Center/Hole Set',
    topWingLeftFlat: 'Top Wing/Left Flat',
    topWingRightFlat: 'Top Wing/Right Flat',
    point: 'Point',
    cornerPost: 'Corner/Post',
    middleDefense: 'Middle/Defense',
    topDefense: 'Top Defense'
  },
  rowing: {
    coxswain: 'Coxswain',
    rower: 'Rower'
  },
  softball: {
    pitcher: 'Pitcher',
    catcher: 'Catcher',
    firstBaseman: 'First Baseman',
    secondBaseman: 'Second Baseman',
    shortstop: 'Shortstop',
    thirdBaseman: 'Third Baseman',
    leftFielder: 'Left Fielder',
    centerFielder: 'Center Fielder',
    rightFielder: 'Right Fielder'
  },
  rugby: {
    looseheadProp: 'Loose-head Prop',
    hooker: 'Hooker',
    tightheadProp: 'Tight-head Prop',
    lock2ndRow: 'Lock/2nd Row',
    blindSideFlanker: 'Blind-side Flanker',
    openSideFlanker: 'Open-side Flanker',
    number8: 'Number 8',
    scrumHalf: 'Scrum Half',
    flyHalf: 'Fly Half',
    leftWing: 'Left Wing',
    insideCenter: 'Inside Center',
    outsideCenter: 'Outside Center',
    rightWing: 'Right Wing',
    fullback: 'Fullback'
  },
  volleyball: {
    setter: 'Setter',
    outsideHitter: 'Outside Hitter',
    middleBlocker: 'Middle Blocker',
    libero: 'Libero',
    oppositeHitter: 'Opposite Hitter'
  },
  stories: {
    subscribeTo: 'Subscribe to get access to more stories from {{name}}'
  },
  reports: {
    descriptionPlaceholder: 'Describe your reason...',
    reportingPost: "Reporting {{name}}'s post",
    reportingShoutout: "Reporting {{name}}'s shoutout",
    reportingStory: "Reporting {{name}}'s story",
    report: 'Report'
  },
  error: {
    noNetwork: 'No network connection',
    somethingWentWrong: 'Something went wrong!',
    pleaseTryAgainLater: 'Please try again later.'
  },
  requestShoutout: {
    discardChanges: 'Discard changes?',
    selectAthlete: 'Select Athlete',
    newRequest: 'New Request',
    requestAShoutout: 'Request a Shoutout',
    itsMine: "It's mine",
    forSomeoneElse: 'For someone else',
    whatIsYourName: 'What is your name?',
    introduction: 'Introduce yourself',
    selectOcassion: 'Select occasion/reason',
    birthday: 'Birthday',
    anniversary: 'Anniversary',
    motivational: 'Motivational',
    mentorship: 'Mentorship',
    gender: 'Gender',
    addInstruction: 'Add instruction (what you would like them to say)',
    deliveryInfo: 'Delivery info',
    videoDelivered: 'Video will be delivered in {{day}} days',
    requestSent: 'Your request has been sent!',
    requestConfirmation:
      "We've just sent out your Shoutout request to {{athlete}}. While completion time is up to {{day}} days, we're optimistic it might be done even sooner.",
    whoThisFor: 'Who is this for?',
    standard: 'Standard ({{price}})',
    bookNow: 'Book now',
    backToShoutout: 'Back to Shoutout',
    maximum18Chars: 'Maximum 18 characters',
    maximum200Chars: 'Maximum 200 characters',
    youCanAdd18Chars: 'You can type up to 18 characters',
    youCanAdd200Chars: 'You can type up to 200 characters'
  },
  yourRequests: {
    view: 'View',
    yourRequests: 'Your Requests',
    myShoutoutRequests: 'My Shoutout Requests',
    shoutoutRequestsFromFans: 'Shoutout Requests from Fans',
    face2faceRequests: 'Face2face Requests',
    all: 'All',
    pending: 'Pending',
    completed: 'Completed',
    unfulfilled: 'Unfulfilled',
    fromAthletes: 'From Athletes',
    fromFans: 'From Fans',
    dayLeft: '{{dayLeft}} Day left',
    daysLeft: '{{dayLeft}} Days left',
    fulfilledOn: 'Fulfilled on {{date}}',
    unfulfilledOn: 'Unfulfilled on {{date}}',
    decline: 'Decline',
    startRecording: 'Start Recording',
    record: 'Record',
    tapForRecording: 'Tap for recording',
    send: 'Send',
    completeTheRequest: 'Complete the Request',
    discardChanges: 'Discard changes?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    awesome: 'Awesome!',
    shoutoutSuccessfullySent: 'Your Shoutout has been successfully sent!',
    declineTheRequest: 'Decline the Request',
    busyConsiderToProfit:
      'We understand you are busy, please consider to profit from your brand on the next fan request.'
  },
  shoutoutsVideoGallery: {
    fromMe: 'From Me',
    fromFellowAthletes: 'From Fellow Athletes',
    for: 'For {{name}}'
  },
  letsChatSports: {
    startChat: 'Start Chat',
    writeTopic: 'Write a topic'
  },
  sorting: {
    mostRecent: 'Most Recent',
    oldest: 'Oldest'
  },
  callToAction: {
    follow: "Don't miss a moment. Follow us and be part of the action all year.",
    subscribe:
      'Level up your connection. Subscribe to Active or Elite and take part in more challenges, perks, and team moments.',
    requestShoutout: 'Your name, my voice—grab your shoutout today',
    sendShoutout: 'Make some noise. Share your shoutout and earn points toward fan perks.',
    face2face: 'Want a one-on-one? Let’s talk live!',
    adPlayaz: 'Put your brand in the spotlight. Advertise directly to active sports fans.',
    fancamLive:
      'Fancam React - Step into the spotlight and share your live moment with the fans, from gameday hype to everyday passion.',
    fancamChallenge:
      'Capture the moment. Submit your photo or video - earn points with every upload and climb with rankings.',
    playToWinPoll:
      'Your voice decides. Pick your Player of the Game and lead your favourite to the top.',
    playToWinQuickQuiz: 'Test your knowledge. Take the quiz and show your fan IQ.',
    predictScore:
      'Make your prediction. Lock in your Half-time and Full-time scores before the action begins.',

    sendAShoutout: 'Send a Shoutout',
    sendShoutoutTitle: 'Send a Shoutout to {{name}}',
    sendShoutoutSubtitle: 'Share a short message to cheer on {{name}}.',
    authenticatedUserMsg: 'Welcome back, {{name}}!',
    start: 'Start',
    createFanProfile: 'Create your fan profile',
    signInToFanProfile: 'Sign in to your fan profile',
    toSendYourShoutout: 'to send your shoutout.',
    yourShoutoutTo: 'Select or Write Shoutout',
    writeYourOwnMessage: 'Write your own message',
    typeMessageOrEmojis: 'Type your message or add emojis…',
    addPhotoOrVideo: 'Add photo or video (optional).',
    postShoutout: 'Post Shoutout',
    shoutoutSentTitle: 'Shoutout sent!',
    shoutoutSentPoints: 'You just earned <highlight>{{points}} points</highlight>!',
    shoutoutSentSubtitle: 'Thanks for cheering on {{name}}!',
    fullTimePredictionAvaialbleInApp: 'Full-Time prediction is available in the app.',
    continueInApp: 'Continue to the App to Predict the Full-Time Score & Play More Games',
    continueInAppShort: 'Continue in App',
    predictFullTimeInApp: 'Predict the Full-Time Score in the App',
    noThanksContinueToChannel: 'No Thanks, Continue to {{name}} Channel',
    presetsLockedMessage:
      'Thank you for supporting <highlight>{{name}}</highlight>! Custom shoutouts are always available. New preset messages will unlock soon — please check back in <highlight>{{time}}</highlight>.',
    presetsLockedMessageNoTime:
      'Thank you for supporting <highlight>{{name}}</highlight>! Custom shoutouts are always available. New preset messages will unlock soon — please check back later.',
    // v3 plural suffixes — i18next is initialized with compatibilityJSON: 'v3'
    timeInHours: '{{count}} hour',
    timeInHours_plural: '{{count}} hours',
    timeInDays: '{{count}} day',
    timeInDays_plural: '{{count}} days',
    presetUnavailable:
      'That preset message just became unavailable. Please pick another or write your own message.',

    predictHalfTime: 'Predict the Half-Time score:',
    submitPrediction: 'Submit Prediction',
    yourPick: 'Your pick',
    yourVoteIs: 'Your Half-Time prediction is {{score}}',
    halfTimePredictionsClosed: 'Half-Time predictions are closed.',
    noPredictionsYet: 'No predictions available yet.',
    confirmHalfTimePrediction: 'Do you want to submit your Half-Time score prediction?',
    yesSubmit: 'Yes, Submit',
    predictionVoteFailed: 'Failed to submit your prediction. Please try again.',
    earnMorePointsByPrediction: 'Earn more points by making a prediction',
    predictionPointsEarned: 'You just earned <highlight>{{points}} points</highlight>!',

    actionFollow: 'Let’s connect!',
    actionSubscribe: 'Unlock premium upgrades',
    actionRequestShoutout: 'Get your shoutout!',
    actionSendShoutout: 'Get your message seen',
    actionF2F: 'Let’s chat live!',
    actionAdPlayaz: 'Boost your brand!',
    actionFancamLive: 'Share your moment',
    actionFancamChallenge: 'Enter the challenge',
    actionPlayToWinPoll: 'Make your pick',
    actionPlayToWinQuickQuiz: 'Test your fan IQ',
    actionPredictScore: 'Call the score',

    startFancamLive: 'Start Fancam React',
    submitPhotoVideo: 'Submit Photo/Video',
    voteNow: 'Vote now',
    takeTheQuiz: 'Take the quiz',
    predictScoreBtn: 'Predict score',
    seeRewards: 'See rewards',
    actionRewards: 'See what this team is giving away',

    warning: 'Warning:',
    mediaChange: 'Media will be changed to be viewed by',
    anyone: 'Anyone',

    chooseEngagement: 'Please choose an engagement first.',
    linkCopied: 'The link has been copied to your clipboard.',
    selectImage: 'Select or add an image before sharing to Instagram.'
  },
  updateApp: {
    newVersionAvailable: 'New Version Available',
    pleaseUpdate: 'Please update app to continue using Playaz4Playaz.',
    updateNow: 'Update Now'
  },
  paymentMethod: {
    selectPaymentMethod: 'Select Payment Method',
    choosePreferredMethod: 'Choose your preferred card payment method',
    cardPaymentOptions: 'Card Payment Options',
    komojuDescription: 'Fast and secure card payments',
    stripeDescription: 'Safe and reliable global payments',
    stripeCardDescription: 'Pay securely with Visa, Mastercard, or AMEX',
    applePayDescription: 'Quick checkout with Apple Pay',
    googlePayDescription: 'Fast payment with Google Pay',
    linkDescription: 'One-click checkout powered by Stripe Link',
    selectedPlan: 'Selected Plan',
    defaultPlanName: 'Premium Subscription',
    month: 'month',
    year: 'year',
    featureUnlimitedAccess: 'Unlimited exclusive access',
    featurePrioritySupport: 'Priority fan support',
    featureExclusiveContent: 'Exclusive athlete content',
    processing: 'Processing...',
    payNow: 'Pay Now',
    noPlanSelected: 'No plan selected',
    securePayment: 'Secure SSL Encrypted Payment',
    paymentMethods: 'Payment Methods',
    savedCards: 'Saved Cards',
    useHostedPage: 'Use Hosted Page',
    hostedPageDescription: 'Complete payment on secure external page',
    cardExpiry: 'Exp',
    noSavedCards: 'No saved cards',
    backToMethods: 'Back to payment methods',
    selectCard: 'Select a card or use hosted page',
    payingWith: 'Paying with',
    planNotFound: 'Plan Not Found',
    planNotFoundDesc: "The subscription plan you're looking for doesn't exist or has been removed.",
    serverError: 'Something Went Wrong',
    serverErrorDesc: "We couldn't load the plan details. Please try again later.",
    backToPlans: 'Back to Plans',
    cancelTitle: 'Cancel Payment?',
    cancelDescription: 'Are you sure you want to cancel? You will lose your current selection.',
    confirmPaymentTitle: 'Confirm Payment',
    confirmPaymentDescription: 'Are you sure you want to proceed with this payment?',
    whatsIncluded: "What's included:",
    total: 'Total',
    subscriptionSummary: 'Subscription Summary',
    pay: 'Pay',
    oneTimePaymentNote: 'This is a one-time payment. You will not be charged again.'
  },
  subscription: {
    paymentSuccessful: 'Payment Received!',
    successMessage: 'Thank you for your subscription. Your account has been upgraded.',
    paymentProcessing: 'Payment Processing',
    processingMessage:
      'We have received your payment and are currently processing it. This may take a few moments.',
    processing: 'Processing',
    fetchInfoError: 'Unable to load subscription information.',
    team: 'Team',
    planTier: 'Plan Tier',
    status: 'Status',
    nextBillingDate: 'Next Billing Date',
    manageSubscription: 'Manage Subscription',
    paymentFailed: 'Payment Failed',
    failureReason:
      'The payment failed or was cancelled. Please check your payment method and try again.',
    tryAgain: 'Try Again',
    contactSupport: 'Contact Support',
    alreadySubscribed: 'You are already subscribed to this team.',
    hero: {
      tagline: 'JOIN THE ULTIMATE',
      title: 'FAN EXPERIENCE',
      subtitle_prefix: 'Unlock',
      subtitle_suffix: 'Like Never Before',
      priceDisclaimer:
        'Note: Prices may vary slightly on the checkout page depending on exchange rates.'
    },
    paywall: {
      eyebrow: 'Memberships',
      title: 'P4P Fan Play Studios',
      subtitle: 'Choose your level and make every match, message, and moment count.',
      free: 'Free',
      switchToAnnual: 'Switch to annual',
      currentPlan: 'Current plan',
      multiplier: '{{multiplier}}x Points Multiplier',
      pricePerMonth: '{{price}} / mo',
      monthly: 'Monthly',
      annual: 'Annual',
      perMonthShort: '{{price}}/mo',
      perYearShort: '{{price}}/yr',
      bestValue: 'Best Value',
      cta: {
        fanchat: 'Select FanChat',
        fanchat_tiri: 'Continue with FanChat + TIRI Pack',
        active: 'Upgrade to Active',
        elite: 'Upgrade to Elite'
      },
      payment: {
        applePay: 'Apple Pay',
        googlePay: 'Google Pay',
        card: 'Card'
      },
      disclosure: "You'll see all details before confirming your subscription.",
      continueFree: 'Continue with Free Plan',
      restore: 'Restore Membership',
      restoring: 'Checking…',
      restoreFound: 'Your membership is active.',
      restoreNotFound: 'No membership found for this account.',
      restoreError: 'Membership check failed. Please try again.',
      terms: 'Terms',
      privacy: 'Privacy'
    },
    studioName: 'by P4P FAN PLAY STUDIOS',
    subscribeButton: 'Subscribe - {{price}}{{currencySign}}/Mo',
    subscribeButtonYearly: 'Subscribe - {{price}}{{currencySign}}/Yr',
    upgradePlan: 'Upgrade Plan',
    downgradeNotAllowed: 'Downgrade Not Allowed',
    continueFreePlan: 'Continue with Free Plan',
    followToSubscribe: 'Follow this team to subscribe',
    alreadySubscribed: 'You are already subscribed to this team.',
    maybeLater: 'Maybe Later',
    supportPaymentVia: 'Support payment via',
    payWith: 'Pay with',
    payWithSuffix: '',
    creditCards: 'Credit Cards',
    applePay: 'Apple Pay',
    googlePay: 'Google Pay',
    upgradeSuccessful: 'Subscription upgraded successfully!',
    upgradeFailed: 'Something went wrong. Please try again.',
    checkingStatus: 'Checking subscription status...',
    subscriptionDetails: 'Subscription Details',
    currentSubscription: 'Current Subscription',
    changePlan: 'Change Plan',
    upgradeYourPlan: 'Change Your Subscription',
    currentPlan: 'Current',
    newPlan: 'New Plan',
    switchToAnnualBilling: 'Switch to annual billing',
    moveToPlan: 'Move to {{plan}}',
    prorationNotice: 'Prorated Billing Applied',
    prorationExplanation: 'The unused time on your current plan is credited, and the difference is charged now.',
    confirmUpgrade: 'Confirm Change',
    manageBilling: 'Manage Billing',
    accessUntil: 'Access Until',
    cancelledGracePeriod: {
      title: 'Subscription Cancelled',
      message:
        'Your subscription has been cancelled and is active until the end of the current billing period. Plan changes are not available during this time.'
    },
    noPlanChange: {
      title: 'Plan Change Unavailable',
      message: 'Plan changes are not available for yearly subscriptions for now.'
    },
    providerMismatch: {
      title: 'Cannot Change Plan',
      message:
        'Your current subscription was purchased through a different payment provider. Please cancel your current subscription first, then purchase the new plan.'
    },
    error: {
      title: 'Something went wrong',
      message: 'We were unable to load the subscription plans. Please try again later.',
      tryAgain: 'Try Again',
      goBack: 'Go Back'
    },
    plans: {
      free: 'FREE',
      pricePerMonth: '{{currencySign}}{{price}}/ Mo',
      pricePerYear: '{{currencySign}}{{price}}/ Yr',
      monthlyOnly: '(Monthly Only)',
      bestValue: 'Best Value',
      basicSupporter: 'Basic Supporter',
      activeSupporter: 'Active Supporter',
      eliteSupporter: 'Elite Supporter'
    },
    features: {
      // Tier-specific web copy. Lookup order on the paywall: features.<tier>.<key>, features.<key>, stored title.
      basic: {
        'live-leaderboard-and-fan-perk-access': 'Leaderboard (Resets Every Game)',
        'play-to-win-predictions-and-quiz': 'Predictions',
        'fan-rewards-and-perks': 'Fan Rewards & Perks',
        'standard-fancam': 'Unlimited Photo & Video Uploads',
        'fanchat-read-only': 'FanChat (Read-Only Access)'
      },
      fanchat: {
        fanchat_write: 'Post, reply, and react in real time'
      },
      active: {
        'basic-supporter-plus': 'Everything in Free Plan + FanChat + TIRI Pack',
        fanchat_write: 'Full FanChat Access'
      },
      elite: {
        'active-supporter-plus': 'Everything in Active',
        fanchat_write: 'Full FanChat Access'
      },
      'live-leaderboard-and-fan-perk-access': 'Live Leaderboard & Fan Perk Access',
      'play-to-win-predictions-and-quiz': 'Play-to-Win: Predictions & Quiz',
      'standard-fancam': 'Standard FanCam',
      'standard-ar-filters': 'Standard AR Filters',
      'shoutouts-to-team-2-per-week': 'Shoutouts to Team: 2/Week',
      '1.0xpoints-earned': '{{multiplier}} x Points Earned',
      'basic-supporter-plus': 'Basic Supporter Plus',
      'premium-ar-filters': '+ Premium AR Filters',
      'unlimited-shoutouts': 'Unlimited Shoutouts',
      'p4p-ai-replay-analysis': 'P4P AI Replay Analysis',
      'fanchat-access-and-content': 'FanChat Access',
      '1.25xpoints-earned': '{{multiplier}} x Points Earned',
      'active-supporter-plus': 'Active Supporter Plus',
      'fanchat-access-and-exclusive-drops': 'FanChat Access + Exclusive Drops',
      '1.5xpoints-earned': '{{multiplier}} x Points Earned',
      descriptions: {
        'live-leaderboard-and-fan-perk-access':
          'Access to live leaderboard and fan perks during matches',
        'play-to-win-predictions-and-quiz':
          'Participate in match predictions and quizzes to earn points and climb the leaderboard',
        'standard-fancam': 'Access to standard FanCam features during matches',
        'standard-ar-filters': 'Access to standard AR filters for your FanCam photos',
        'shoutouts-to-team-2-per-week':
          'Get shoutouts to your team 2 times per week on our social media channels',
        '1.0xpoints-earned': 'Earn points at a {{multiplier}}x rate for all your activities',
        'basic-supporter-plus': 'All features of Basic Supporter plus additional perks',
        'premium-ar-filters':
          'Access to exclusive premium AR filters for your FanCam photos and videos',
        'unlimited-shoutouts': 'Get unlimited shoutouts to your team on our social media channels',
        'p4p-ai-replay-analysis':
          'Access AI-powered replay analysis to review your match predictions and performance',
        'fanchat-access-and-content':
          'Exclusive access to FanChat where you can interact with other fans',
        '1.25xpoints-earned':
          'Earn points at a {{multiplier}}x rate for all your activities, helping you climb the leaderboard faster',
        'active-supporter-plus': 'All features of Active Supporter plus exclusive elite perks',
        'fanchat-access-and-exclusive-drops':
          'Exclusive access to FanChat with special content drops and interactions with players and influencers',
        '1.5xpoints-earned':
          'Earn points at a {{multiplier}}x rate for all your activities, giving you the best chance to top the leaderboard'
      }
    },
    admin: {
      title: 'Subscription Plans',
      syncAll: 'Sync All',
      syncing: 'Syncing...',
      syncPlan: 'Sync',
      syncingPlan: 'Syncing...',
      syncPlanDone: 'Plan synced with Stripe',
      search: {
        placeholder: 'Search team',
        clear: 'Clear search',
        noResultsTitle: 'No teams match “{{query}}”',
        noResultsMessage: 'Check the spelling or try a shorter name.'
      },
      createPlan: 'Create Plan',
      unknownTeam: 'Unknown Team',
      stats: {
        synced: 'synced',
        pending: 'pending',
        error: 'error',
        plan: 'plan',
        plan_plural: 'plans'
      },
      empty: {
        title: 'No subscription plans yet',
        message: 'Create your first subscription plan to start managing pricing across countries.'
      },
      table: {
        country: 'COUNTRY',
        title: 'PLAN TITLE',
        monthly: 'MONTHLY',
        yearly: 'YEARLY',
        currency: 'CURRENCY',
        sync: 'SYNC',
        status: 'STATUS'
      },
      status: {
        active: 'Active',
        inactive: 'Inactive',
        synced: 'Synced',
        pending: 'Pending',
        error: 'Error'
      },
      filters: {
        allCountries: 'All Countries',
        allStatus: 'All Status'
      },
      tabs: { plans: 'Plans', campaigns: 'Campaigns' },
      campaigns: {
        createButton: 'Create campaign',
        empty: {
          title: 'No campaigns yet',
          message: 'Create one to unlock paid features for a set period.'
        },
        allTeams: 'All teams',
        removeTeam: 'Remove {{name}}',
        jstHint: 'Times are in JST (UTC+9).',
        lockedHint: 'Only the name and end time can change while a campaign is running.',
        endedHint: 'This campaign has ended. Create a new campaign to run it again.',
        endNow: 'End now',
        endConfirmHeading: 'End this campaign now?',
        endConfirmText: 'Users lose free access immediately.',
        conflict: {
          title: 'This time frame overlaps another campaign:',
          allTeams: 'All teams'
        },
        status: { scheduled: 'Scheduled', active: 'Active', ended: 'Ended' },
        column: { name: 'Name', status: 'Status', features: 'Features', teams: 'Teams', starts: 'Starts', ends: 'Ends' },
        feature: { fanchat_write: 'FanChat', shoutout_unlimited: 'Shoutouts', tiri_tag_it: 'TIRI Tag IT' },
        panel: { createTitle: 'Create campaign', editTitle: 'Edit campaign', viewTitle: 'Campaign details' },
        field: {
          name: 'Name',
          features: 'Features',
          teams: 'Teams',
          allTeams: 'All teams',
          startsAt: 'Starts (JST)',
          endsAt: 'Ends (JST)'
        },
        button: { create: 'Create campaign', save: 'Save changes', saving: 'Saving…' },
        success: { created: 'Campaign created', saved: 'Campaign saved', ended: 'Campaign ended' },
        error: {
          nameRequired: 'Enter a name.',
          featuresRequired: 'Select at least one feature.',
          teamsRequired: 'Select at least one team, or choose all teams.',
          startRequired: 'Enter a start time.',
          endRequired: 'Enter an end time.',
          endAfterStart: 'End time must be after the start time.'
        }
      },
      panel: {
        createTitle: 'Create Subscription Plan',
        editTitle: 'Edit Subscription Plan',
        featuresAccessHint: 'FanChat, Shoutouts and TIRI Tag IT switches control access. Turn one off and this plan no longer unlocks it.',
        section: {
          details: 'Plan Details',
          pricing: 'Pricing',
          features: 'Features',
          featuresToggle: 'Features (toggle active/inactive)',
          integration: 'Integration Status'
        },
        field: {
          country: 'Country',
          selectCountry: 'Select a country',
          team: 'Team',
          selectTeam: 'Select team...',
          loadingTeams: 'Loading teams...',
          tier: 'Tier',
          selectTier: 'Select tier...',
          loadingTiers: 'Loading tiers...',
          autoDetected: 'auto-detected from team',
          changeTeam: 'Change team',
          title: 'Plan Title',
          titlePlaceholder: 'e.g. Active Supporter',
          badge: 'Badge',
          badgePlaceholder: 'e.g. VIP',
          description: 'Description',
          descriptionPlaceholder: 'e.g. Standard subscription tier',
          monthly: 'Monthly',
          monthlyDiscount: 'Monthly Discount %',
          yearly: 'Yearly',
          yearlyDiscount: 'Yearly Discount %',
          basicTierPriceNote: 'Basic plans are free — prices are fixed at 0',
          planActive: 'Plan Active',
          planActiveDesc: "Inactive plans won't be shown to users",
          featureTitle: 'Title',
          featureTitlePlaceholder: 'Feature title',
          featureKey: 'Key',
          featureDesc: 'Description',
          featureDescPlaceholder: 'Feature description',
          stripeProductId: 'Stripe Product ID',
          stripeStatus: 'Stripe: {{status}}'
        },
        button: {
          addFeature: 'Add Feature',
          save: 'Save',
          saving: 'Saving...',
          update: 'Update Plan',
          create: 'Create Plan'
        },
        error: {
          countryRequired: 'Country is required',
          teamRequired: 'Team is required',
          stripeRequired: 'Team must connect their Stripe account before a plan can be created',
          profitSplitTotal: 'P4P + Team + VAT must equal 100% (currently {{total}}%)',
          tierRequired: 'Tier is required',
          titleRequired: 'Title is required',
          priceRequired: 'At least one price is required',
          featureRequired: 'At least one feature is required',
          featureFieldsRequired: 'Feature title and key are required'
        },
        stripeStatus: {
          checking: 'Checking Stripe status…',
          connected: 'Stripe Connected',
          connectedHint: '— profit splits will apply',
          notConnected: 'Stripe Not Connected',
          notConnectedHint: '— team must connect to receive splits'
        },
        success: {
          updated: 'Plan updated successfully',
          created: 'Plan created successfully'
        }
      }
    }
  },
  subscriptions: {
    admin: {
      title: 'Subscriptions Overview',
      tabs: {
        overview: 'Overview',
        mrr: 'MRR',
        churn: 'Churn',
        subscribers: 'Subscribers',
        history: 'History'
      },
      overview: {
        total: 'total subscribers',
        paymentMethods: {
          title: 'Payment Methods',
          byProvider: 'By Provider',
          byBrand: 'By Type / Brand',
          empty:
            'No active subscribers yet. Payment method data will appear here once subscribers sign up.'
        },
        mrr: {
          title: 'Monthly Recurring Revenue',
          subtitle: 'Detailed revenue view by currency with country and plan breakdowns',
          currencyCount: 'currencies',
          byCountry: 'By Country',
          byPlan: 'By Plan',
          byTeam: 'By Team',
          monthlyPlans: 'Monthly plans',
          yearlyPlans: 'Yearly plans',
          plan: 'Plan',
          team: 'Team',
          country: 'Country',
          countryCode: 'Country Code',
          currency: 'Currency',
          totalMrr: 'Total MRR',
          subscribers: 'Subscribers',
          monthly: '/ month',
          empty:
            'No active subscriptions yet. MRR metrics will appear once subscriptions are active.'
        },
        subscriberCount: {
          title: 'Subscriber Status',
          empty: 'No subscriber data available.',
          group: {
            growthRetention: 'Growth & Retention',
            conversionPipeline: 'Conversion Pipeline',
            churnRiskExposure: 'Churn & Risk Exposure',
            churned: 'Churned'
          },
          initiated: 'Initiated',
          processing: 'Processing',
          success: 'Success',
          failed: 'Failed',
          pending: 'Pending',
          active: 'Active',
          retrying: 'Retrying',
          suspended: 'Suspended',
          cancelled: 'Cancelled',
          deleted: 'Deleted'
        },
        churn: {
          title: 'Churn Rate',
          subtitle: 'Cancelled / Active during period',
          period: 'Period',
          periods: {
            '30d': 'Last 30 Days',
            '90d': 'Last 90 Days',
            '1y': 'Last 1 Year',
            all: 'All Time'
          },
          churnRate: 'Churn Rate',
          cancelled: 'Cancelled',
          activeDuringPeriod: 'Active in Period',
          na: 'N/A',
          byCountry: 'By Country',
          byPlan: 'By Plan',
          byTeam: 'By Team',
          country: 'Country',
          countryCode: 'Country Code',
          plan: 'Plan',
          teamName: 'Team Name',
          cancellations: 'Cancellations',
          empty: 'No churn data available for this period.',
          allTimeNote: 'Churn rate is not calculated for All Time.'
        },
        renewals: {
          title: 'Renewal Success / Failure',
          periods: {
            '30d': 'Last 30 Days',
            '90d': 'Last 90 Days',
            '1y': 'Last 1 Year',
            all: 'All Time'
          },
          successes: 'Successes',
          failures: 'Failures',
          successRate: 'Success Rate',
          provider: 'Provider',
          empty: 'No renewal data for this period.'
        }
      },
      revenueSplit: {
        title: 'Revenue Split',
        filters: {
          startDate: 'Start date',
          endDate: 'End date',
          countries: 'Countries',
          selectCountries: 'Select countries',
          selectedCountries: '{{count}} selected',
          team: 'Team',
          allTeams: 'All teams',
          loadingTeams: 'Loading teams...',
          interval: 'Interval',
          all: 'All',
          monthly: 'Monthly',
          yearly: 'Yearly',
          exportCsv: 'Export CSV',
          downloading: 'Downloading...'
        },
        currencySection: '{{currency}} Section',
        table: {
          team: 'Team',
          country: 'Country',
          currency: 'Currency',
          grossRevenue: 'Gross Revenue',
          splitVisual: 'Split',
          p4pPercent: 'P4P % (W)',
          p4pAmount: 'P4P Amount',
          teamPercent: 'Team % (W)',
          teamAmount: 'Team Amount',
          vatPercent: 'VAT % (W)',
          vatAmount: 'VAT Amount',
          plans: 'Plans'
        },
        planTable: {
          plan: 'Plan',
          revenueShare: 'Revenue Share %',
          p4p: 'P4P %',
          team: 'Team %',
          vat: 'VAT %',
          consistency: 'Consistency'
        },
        splitLegend: {
          p4p: 'P4P',
          team: 'Team',
          vat: 'VAT'
        },
        totals: {
          label: '{{currency}} TOTAL'
        },
        consistency: {
          ok: '100% OK',
          warning: 'Check split'
        },
        manualTransferAudit: {
          title: 'Manual Transfer Audit',
          tab: {
            revenueSplit: 'Revenue Split',
            manualAudit: 'Manual Transfer Audit'
          },
          filters: {
            status: 'Status',
            searchPlaceholder: 'Search by team name...'
          },
          status: {
            pending: 'Pending',
            reconciled: 'Reconciled',
            not_required: 'Not Required'
          },
          skipReason: {
            no_profit_split: 'No Profit Split',
            no_connected_account: 'No Connected Account',
            cross_region: 'Cross Region'
          },
          table: {
            occurredAt: 'Date',
            interval: 'Interval',
            manualDue: 'Manual Due',
            reconciledBy: 'Reconciled By',
            reconciledAt: 'Reconciled At',
            note: 'Note',
            skipReason: 'Skip Reason',
            actions: 'Actions'
          },
          reconcile: {
            action: 'Reconcile',
            markPending: 'Mark Pending',
            by: 'Reconciled by',
            note: 'Note (optional)',
            confirm: 'Confirm',
            cancel: 'Cancel',
            notePlaceholder: 'e.g. paid via bank transfer on 2024-03-01'
          },
          totals: {
            outstanding: 'Outstanding',
            reconciled: 'Reconciled'
          },
          pagination: {
            showing: 'Showing {{from}}-{{to}} of {{total}}'
          }
        },
        empty: 'No data found for the selected filters.',
        error: 'Failed to load revenue split report.'
      },
      subscribers: {
        subscriber: 'Subscriber',
        team: 'Team',
        plan: 'Plan',
        status: 'Status',
        provider: 'Provider',
        amount: 'Amount',
        refund: {
          title: 'Refund Request',
          requestId: 'Refund Request ID',
          amount: 'Amount',
          provider: 'Provider',
          userNote: 'User note',
          requested: 'Requested',
          updated: 'Updated',
          providerPaymentId: 'Provider Payment ID',
          approvalReason: 'Approval note',
          rejectionReason: 'Rejection reason',
          providerRefundId: 'Provider Refund ID',
          processedBy: 'Processed By',
          subscriptionId: 'Subscription ID',
          providerSubId: 'Provider Sub ID',
          adminMessagePlaceholder: 'Admin message (optional)',
          approve: 'Approve Refund',
          reject: 'Reject',
          badge: 'Refund Requested'
        },
        searchPlaceholder: 'Search by name, username, or email...',
        empty: 'No subscribers found.',
        emptySearch: 'No subscribers match your search.',
        endOfList: 'End of list',
        error: 'Failed to load subscribers. Please try again.',
        detail: {
          subscriptionDetails: 'Subscription Details',
          eventTimeline: 'Event Timeline',
          eventsCountOne: '{{count}} event',
          eventsCountOther: '{{count}} events',
          noEvents: 'No billing events recorded.',
          started: 'Started',
          currentPeriodStart: 'Current Period Start',
          currentPeriodEnd: 'Current Period End',
          nextRenewal: 'Next Renewal',
          interval: 'Interval',
          renewals: 'Renewals',
          failures: 'Failures',
          cancelledAt: 'Cancelled',
          scheduledCancel: 'Scheduled Cancel',
          endedAt: 'Ended',
          reason: 'Reason',
          created: 'Created',
          paymentMethod: 'Payment Method',
          cardBrand: 'Brand',
          cardLast4: 'Card Number',
          cardExpiry: 'Expiry',
          paymentType: 'Type',
          period: 'Period',
          expiryShort: 'Exp',
          intervalShort: {
            monthly: 'mo',
            yearly: 'yr'
          },
          eventTypes: {
            checkout_initiated: 'Checkout Initiated',
            subscribed: 'Subscribed',
            renewed: 'Renewed',
            upgraded: 'Upgraded',
            downgraded: 'Downgraded',
            payment_succeeded: 'Payment Succeeded',
            payment_failed: 'Payment Failed',
            renewal_failed: 'Renewal Failed',
            cancelled: 'Cancelled',
            suspended: 'Suspended',
            refund_requested: 'Refund Requested',
            refund_approved: 'Refund Approved',
            refund_rejected: 'Refund Rejected'
          }
        }
      },
      status: {
        initiated: 'Initiated',
        processing: 'Processing',
        success: 'Active',
        active: 'Active',
        retrying: 'Retrying',
        suspended: 'Suspended',
        cancelled: 'Cancelled',
        failed: 'Failed',
        pending: 'Pending',
        deleted: 'Deleted',
        refunded: 'Refunded'
      },
      comingSoon: 'Coming soon'
    }
  },
  admin: {
    readOnlyField: 'This is a read-only field',
    goalRush: {
      tabs: {
        sessions: 'Sessions',
        defaults: 'Defaults',
        overrides: 'Overrides'
      },
      team: 'Channel',
      groups: {
        session: 'Session & targets',
        points: 'Points',
        others: 'Others'
      },
      rows: {
        gaps: 'Defender gaps',
        bonus: 'Bonus Targets Inside the Net'
      },
      fields: {
        sessionDurationSec: 'Session length',
        targetKicks: 'Kicks target',
        targetGoals: 'Goals target',
        kickMilestonePoints: 'Kick Milestone',
        goalMilestonePoints: 'Goal Milestone',
        pointsPerKick: 'Points per kick',
        pointsPerGoal: 'Points per goal',
        defenderPatternId: 'Defender pattern',
        others_gapIntervalSec: 'Gap every (seconds)',
        others_gapDurationMs: 'Gap lasts (seconds)',
        others_minGapWidth: 'Minimum gap width',
        others_bonusIntervalSec: 'Bonus target every (seconds)',
        others_bonusVisibleMs: 'Bonus target visible for (seconds)',
        pointsPerBonusHit: 'Bonus target hit reward'
      },
      help: {
        sessionDurationSec: 'How long a session runs before it resets.',
        targetKicks: 'Collective kicks that end the session as reached.',
        targetGoals: 'Collective goals that end the session as reached.',
        kickMilestonePoints: 'Points every fan who kicked gets when the kicks target is reached.',
        goalMilestonePoints: 'Points every fan who kicked gets when the goals target is reached.',
        pointsPerKick: 'Paid for every kick.',
        pointsPerGoal: 'Paid on top for a goal.',
        others_gapIntervalSec: 'How often the defenders open a gap.',
        others_gapDurationMs: 'How long a gap stays open.',
        others_minGapWidth: 'In field widths (1 = the whole pitch).',
        others_bonusIntervalSec: 'How often a bonus target appears.',
        others_bonusVisibleMs: 'How long a bonus target stays.',
        pointsPerBonusHit: 'Points to the fan whose goal hits a bonus target.'
      },
      range: 'Range {{min}}–{{max}}.',
      durationRange: '1–60 minutes, 1–60 hours or 1–365 days.',
      patterns: {
        classic: {
          label: 'Classic',
          description: 'Rotates sweep, oscillate and arc every 20 seconds.'
        },
        sweep: {
          label: 'Sweep',
          description: 'Side to side at a steady pace.'
        },
        oscillate: {
          label: 'Oscillate',
          description: 'Smooth swing, slowing at the edges.'
        },
        arc: {
          label: 'Arc',
          description: 'Curved path that also moves up and down.'
        }
      },
      errors: {
        required: 'Required.',
        integer: 'Whole numbers only.',
        range: 'Must be between {{min}} and {{max}}.',
        durationRange: {
          minutes: 'Must be between 1 and {{max}} minutes.',
          hours: 'Must be between 1 and {{max}} hours.',
          days: 'Must be between 1 and {{max}} days.'
        }
      },
      loading: 'Loading…',
      save: 'Save changes',
      saving: 'Saving…',
      saved: 'GoalRush rules saved.',
      saveFailed: 'Could not save the GoalRush rules.',
      cancel: 'Cancel',
      confirm: 'Confirm',
      applies: {
        session: 'Changes apply from the next session.',
        points: 'Changes apply from the next session.',
        others: 'Changes apply from the next session.'
      },
      defaults: {
        notStarted:
          'GoalRush is not running on this channel yet. Save the defaults below to start it — fans see it on the team channel right away.',
        confirmFirstSave:
          'Start GoalRush on this channel with these defaults? The default session starts now and fans see it on the team channel.',
        alwaysOn:
          'A default GoalRush runs on this channel all the time. Each session ends when a target is reached or its time is up, then a new one starts. While an override runs, the default session is paused and its clock stops.',
        confirmSave:
          'Save this channel’s default GoalRush? The running session keeps its current rules; changes apply from the next session.'
      },
      overrides: {
        enable: 'Enable override',
        on: 'On',
        off: 'Off',
        channelOff:
          'GoalRush is not set up for this channel yet. Save its Defaults first to run an override.',
        warning:
          'Enabling this override pauses the running default session and starts this one now. The default session resumes when the override ends.',
        confirmEnable:
          'Enable this override? The running default session pauses now and fans see the override start.',
        confirmDisable:
          'Disable the override? If it is running, it ends now and the default session resumes.',
        confirmSave:
          'Save the override? If it is running, it keeps its current rules; changes apply the next time it starts.'
      },
      sessions: {
        title: 'Sessions',
        refresh: 'Refresh',
        more: 'Load more',
        none: 'No sessions yet — one starts when a fan opens GoalRush.',
        kind: {
          default: 'Default session',
          override: 'Override session'
        },
        status: {
          running: 'Running',
          paused: 'Paused',
          completed: 'Completed',
          timeUp: 'Time up',
          terminated: 'Terminated'
        },
        pausedSince: 'Paused by an override since {{time}}',
        liveNow: 'Live now',
        previous: 'Previous sessions',
        noLimit: 'No time limit',
        kicks: 'Kicks / target',
        goals: 'Goals / target',
        fans: 'Fans',
        detail: {
          title: 'Session details',
          progress: 'Progress',
          kicks: 'Kicks',
          goals: 'Goals',
          endReason: 'Ended because',
          endReasons: {
            target_reached: 'A target was reached',
            target_not_reached: 'Time ran out',
            admin_override: 'An override ended it',
            disabled: 'GoalRush was switched off'
          },
          targetHit: {
            kicks: 'Kicks target reached · {{time}}',
            goals: 'Goals target reached · {{time}}'
          },
          rewardPerFan: '+{{value}} pts per fan',
          gameplay: 'Gameplay',
          stats: {
            blocked: 'Blocked',
            nearMiss: 'Near misses',
            collisions: 'Collisions',
            rebounds: 'Rebounds',
            bonusHits: 'Bonus hits'
          },
          pauses: 'Pauses',
          pauseOngoing: 'Still paused',
          rules: 'Rules used',
          kickCooldown: 'Kick cooldown',
          gapsSummary: 'Every {{every}}s, open {{open}}, min width {{width}}',
          bonusSummary: 'Every {{every}}s, visible {{visible}}',
          off: 'Off',
          fans: 'Fans',
          fansTop: 'Top {{shown}} of {{total}} by kicks',
          fansNone: 'No fans have joined this session yet.',
          fan: 'Fan',
          points: 'Points',
          deletedFan: 'Deleted user',
          settlement: 'Settlement',
          settled: 'Points paid out {{time}}.',
          settlePending: 'Ended — points not paid out yet.',
          settleOnEnd: 'Points are paid out when the session ends.'
        }
      },
      noChannel: 'Pick a channel to manage its GoalRush rules.'
    },
    nav: {
      users: 'Users',
      teams: 'Teams',
      updates: 'Updates',
      posts: 'Posts',
      products: 'Products',
      orders: 'Orders',
      pricing: 'Pricing',
      games: 'Games',
      generalSettings: 'General Settings',
      shoutouts: 'Shoutouts',
      subscription: 'Subscription',
      revenueSplit: 'Revenue Split',
      auditLogs: 'Audit Logs',
      stripeRequests: 'Stripe Requests',
      webhookLogs: 'Webhook Logs',
      quickQuiz: 'Quick Quiz',
      fanWave: 'FanWave',
      goalRush: 'GoalRush',
      liveStatsEngagement: 'Live Stats Engagement',
      polls: 'Polls',
      tiri: 'TIRI',
      insights: 'Insights',
      email: 'Email Manager'
    },
    auditLogs: {
      title: 'Audit Logs',
      allActors: 'All Actors',
      allTargets: 'All Targets',
      allActions: 'All Actions',
      noLogs: 'No audit logs',
      prev: 'Prev',
      next: 'Next',
      table: {
        actor: 'Actor',
        target: 'Target',
        action: 'Action',
        time: 'Time',
        ip: 'IP'
      },
      panel: {
        title: 'Audit log',
        actor: 'Actor',
        target: 'Target',
        action: 'Action',
        entityType: 'Entity Type',
        refundRequestId: 'Refund Request ID',
        subscriptionId: 'Subscription ID',
        timestamp: 'Timestamp',
        ipAddress: 'IP Address',
        beforeState: 'Before state',
        afterState: 'After state',
        na: 'N/A'
      },
      subscriptionCard: {
        id: 'ID',
        teamId: 'Team ID',
        teamName: 'Team Name',
        tier: 'Tier',
        title: 'Title',
        description: 'Description',
        active: 'Active',
        yes: 'Yes',
        no: 'No',
        country: 'Country',
        created: 'Created',
        updated: 'Updated',
        stripeProductId: 'Stripe Product ID',
        features: 'Features',
        prices: 'Prices',
        profitSplit: 'Profit Split',
        syncStatus: 'Sync Status',
        key: 'Key',
        badge: 'Badge',
        amount: 'Amount',
        currency: 'Currency',
        interval: 'Interval',
        stripePriceId: 'Stripe Price ID',
        discount: 'Discount'
      },
      refundCard: {
        status: 'Status',
        user: 'User',
        email: 'Email',
        refundRequestId: 'Refund Request ID',
        billingSubscriptionId: 'Billing Subscription ID',
        payment: 'Payment',
        amount: 'Amount',
        provider: 'Provider',
        interval: 'Interval',
        subscriptionStatus: 'Subscription Status',
        providerPaymentId: 'Provider Payment ID',
        reason: 'Reason',
        approval: 'Approval',
        providerRefundId: 'Provider Refund ID',
        providerSubscriptionId: 'Provider Subscription ID',
        rejection: 'Rejection',
        processedAt: 'Processed At'
      },
      subscriptionsOverview: 'Subscriptions Overview',
      reporting: 'Reporting',
      webhookLogs: 'Webhook Logs'
    },
    liveStatsEngagement: {
      title: 'Live Stats Engagement',
      liveUpdateImpressions: 'Live Update Impressions',
      liveUpdateImpressionsDesc: 'Number of live stat updates fans actually saw.',
      activeViewingTime: 'Active Viewing Time',
      activeViewingTimeDesc: 'Total time Live Stats was visible',
      avgPerFan: 'avg per fan',
      returnFrequency: 'Return Frequency',
      returnFrequencyDesc: 'How often fans came back to Live Stats',
      avgReturnsPerFan: 'avg returns per fan',
      selectTeamPrompt: 'Select a team to view engagement impressions'
    },
    /**
     * TIRI — the admin menu at `/admin/tiri` (`screens/Admin/screens/Tiri`) plus the TIRI card on
     * General Settings › Reward Points.
     *
     * Deliberately separate from the TOP-LEVEL `tiri` namespace, which is the fan-facing Rate It
     * web landing and shares its key paths with mobile. Nothing here is ever seen by a fan: it is
     * the admin's vocabulary — "Labeled", "Pending", "In feed" — so the two must not be merged.
     */
    tiri: {
      title: 'TIRI',
      // Module names are brand names and stay in English in every locale, but they are keyed
      // rather than inlined so the badge, the filter, the summary tile and the settings card all
      // read from one place. `tagit`/`rateit` are the server's module enum verbatim — the list
      // item looks a badge's label up from the id the row was handed, so renaming either key
      // silently empties a badge.
      modules: {
        tagit: 'Tag It',
        rateit: 'Rate It'
      },
      filters: {
        labelStatus: 'Label status',
        module: 'Module',
        source: 'Source',
        team: 'Filter by Team',
        // Leads every dropdown and is each one's default — the list opens showing everything
        // rather than pre-filtered to a queue.
        all: 'All'
      },
      sources: {
        fancam: 'FanCam',
        direct: 'Direct Upload'
      },
      // Tag It's labeling state. A Rate It-only item has nothing to classify, so it is neither
      // pending nor labeled and the row renders a dash rather than reaching for one of these.
      status: {
        labeled: 'Labeled',
        pending: 'Pending'
      },
      mediaTypes: {
        image: 'Image',
        video: 'Video'
      },
      // Shared by the list's column headings and the detail panel's labels, so a column and the
      // field it opens onto can never end up named two different things. `media`..`uploadedAt`
      // are in column order — see `COLUMNS` in `Tiri/components/GridTable.js`.
      fields: {
        media: 'Media',
        modules: 'Modules',
        source: 'Source',
        uploader: 'Uploader',
        team: 'Team',
        status: 'Status',
        category: 'Category',
        inFeed: 'In feed',
        uploadedAt: 'Uploaded At',
        // Panel-only: the list has no column for either.
        moderation: 'Moderation',
        shownToFans: 'Shown to fans'
      },
      feed: {
        live: 'Live',
        notLive: 'Not live'
      },
      /** The category cell of a Rate It-only row, which has no category to show. */
      notApplicable: 'N/A',
      panel: {
        /** Header before a row has been resolved out of the store. */
        fallbackTitle: 'TIRI item',
        title: "{{name}}'s upload",
        /** Stands in for the uploader's name in `title` when the row has no owner. */
        unknownUploader: 'Unknown',
        mediaAlt: 'TIRI media',
        sourceDirect: 'Team Channel upload (not a FanCam)',
        sourceFancam: 'FanCam Challenge',
        noCategory: 'This is a Rate It item, so there is no category to set.',
        categoryPlaceholder: 'Select the correct category',
        yes: 'Yes',
        no: 'No',
        save: 'Save',
        saving: 'Saving...',
        selectCategoryFirst: 'Select a category before saving.',
        saved: 'Tag It category saved.'
      },
      /** General Settings › Reward Points › TIRI. */
      settings: {
        title: 'TIRI',
        description: 'Point settings for the Tag It and Rate It modules',
        participationPoints: 'Participation Points',
        /** ONE description for one cycle. The two per-module strings this replaced are gone:
         * naming a module would misdescribe a cycle either one can complete. */
        participationPointsDesc:
          'Awarded for every 5 completions across Tag It and Rate It, in any combination. 0 pays nothing',
        referralPoints: 'Referral Points',
        referralPointsDesc: 'Shown to fans as what each side earns for an invite'
      }
    },
    /** General Settings › Reward Points › Referral Prompt Snooze (FanCam + Rate It). */
    referralSnooze: {
      title: 'Referral Prompt Snooze',
      description:
        'Applies to both the FanCam Challenge and Rate It “invite a friend” prompts. Declines are counted separately for each.',
      label: 'Snooze Referral Prompts For',
      placeholder: 'Length',
      hint: 'A fan who declines the invite prompt twice within {{length}} won’t be asked again for {{length}}.',
      saveInvalid: '"Snooze Referral Prompts For" is not valid. Check the message under the field.',
      units: {
        minutes: 'Min',
        hours: 'Hours',
        days: 'Days'
      },
      errors: {
        maxMinutes: 'Minutes can be at most 60. Use Hours for longer.',
        maxHours: 'Hours can be at most 24. Use Days for longer.',
        invalid: 'Enter a length of at least 1 minute, in whole minutes.'
      },
      // v3 plural suffixes — i18next is initialized with compatibilityJSON: 'v3'
      duration: {
        day: '{{count}} day',
        day_plural: '{{count}} days',
        hour: '{{count}} hour',
        hour_plural: '{{count}} hours',
        minute: '{{count}} minute',
        minute_plural: '{{count}} minutes'
      }
    },
    /** Admin › Insights › the per-item activity drawer (`ItemActivityDrawer.js`). */
    insights: {
      /**
       * A FanCam / TIRI item whose document is gone. Its events are kept — the engagement
       * happened — so the row stays, marked with this, and labelled from what the delete event
       * recorded about it.
       */
      deleted: 'Deleted',
      /** `{{date}}` is the delete event's date, already formatted for the locale. */
      deletedOn: 'Deleted {{date}}',
      /** GoalRush analytics (brief §7) for one team or all teams, from /admin/insights/goalrush. */
      goalrushStats: {
        title: 'GoalRush analytics',
        open: 'Open GoalRush analytics',
        refresh: 'Refresh GoalRush analytics',
        scopeAllTeams: 'All teams',
        scopeAllTime: 'All time',
        dailyCardTitle: 'GoalRush Analytics',
        viewMore: 'View more',
        subtitle: 'Sessions started in the selected period; all teams when no team is picked.',
        empty: 'No data for this period',
        groups: {
          volume: 'Volume',
          rates: 'Gameplay',
          milestones: 'Milestones',
          sessions: 'Sessions',
          engagement: 'Engagement',
          events: 'Events'
        },
        sessions: 'Sessions',
        sessionsHint: 'Started in the period',
        kicks: 'Total kicks',
        goals: 'Total goals',
        kicksPerSession: 'Kicks per session',
        goalsPerSession: 'Goals per session',
        fans: 'Active participants',
        fansHint: 'Joined or kicked',
        kickers: 'Fans who kicked',
        goalRate: 'Goal rate',
        goalRateHint: 'Goals ÷ kicks',
        blockRate: 'Defender block rate',
        blockRateHint: 'Blocked ÷ kicks (defender or ball)',
        defenderHitRate: 'Defender hit rate',
        defenderHitRateHint: 'Kicks that touched a defender',
        collisionRate: 'Ball-to-ball collision rate',
        collisionRateHint: "Kicks that hit another fan's ball",
        nearMissRate: 'Near-miss rate',
        milestone: {
          kicks: {
            completion: 'Kicks milestone completion',
            medianTime: 'Time to kicks milestone'
          },
          goals: {
            completion: 'Goals milestone completion',
            medianTime: 'Time to goals milestone'
          },
          reachedOf: '{{reached}} of {{ended}} ended sessions',
          avg: 'Median · average {{value}}'
        },
        endedSessions: 'Ended sessions',
        autoResets: 'Auto-resets',
        autoResetsHint: 'Target reached or time ran out',
        avgSessionDuration: 'Average session length',
        avgSessionDurationHint: 'Excluding time paused',
        pausedByOverride: 'Paused by override',
        pausedByOverrideHint: 'Default sessions set aside for an override',
        avgKicksPerFan: 'Kicks per user',
        avgGoalsPerFan: 'Goals per user',
        avgSessionsPerFan: 'Sessions per fan',
        participationEvents: 'Participation events',
        goalEvents: 'Goal events',
        avgPerSec: 'Events / sec (average)',
        avgPerSecHint: 'Over minutes with activity',
        peakPerSec: 'Events / sec (peak)',
        peakPerSecHint: 'Busiest minute',
        resetReasons: 'Reset reasons',
        resetReasonsHint: 'Why sessions ended',
        endReason: {
          target_reached: 'Target reached',
          target_not_reached: 'Time ran out',
          admin_override: 'Admin override',
          disabled: 'Switched off',
          active: 'Live',
          unknown: 'Unknown'
        },
        daily: 'Kicks per day',
        dailyHint: 'Kicks, with goals beside them',
        kicksCount: '{{value}} kicks',
        goalsCount: '{{value}} goals'
      },
      /** FanChat 2.0 figures for one team and period, from /admin/insights/fanchat. */
      fanchatTopics: {
        title: 'FanChat 2.0 topic chats',
        messages: 'Messages',
        previews: 'Previews',
        joins: 'Joins',
        joinRate: 'Join rate',
        joinRateHint: 'Joins ÷ previews',
        topicsCreated: 'Chats created',
        topicsCreatedHint: 'Including drafts',
        topicsPublished: 'Chats published',
        medianFirstResponse: 'Median first response',
        activeNow: 'Active now',
        activeNowHint: 'Right now, whatever the dates',
        /** Free Plan allowance and follow figures for the team and period. */
        access: {
          title: 'FanChat access',
          freeFansUsed: 'Free Plan fans who posted or replied',
          limitReachedFans: 'Fans who reached a limit',
          limitReachedPosts: 'Post limit reached',
          limitReachedReplies: 'Reply limit reached',
          paywallLimitShown: 'Paywall shown at a limit',
          followPromptShown: 'Follow prompt shown',
          followRefused: 'Refused for not following',
          noData: 'No data yet',
          sinceHint: 'Counted since {{date}}'
        },
        /** One line under a topic row in the FanChat items list. */
        topic: {
          by: 'by {{name}}',
          published: 'Published {{date}}',
          membersNow: '{{count}} members now',
          messages: '{{count}} messages',
          previews: '{{count}} previews',
          joins: '{{count}} joins',
          firstResponse: 'First reply {{time}}',
          status: { published: 'Published', deleted: 'Deleted', draft: 'Draft' }
        },
        duration: {
          seconds: '{{s}}s',
          minutes: '{{m}}m {{s}}s',
          hours: '{{h}}h {{m}}m'
        }
      },
      /** The module drill-down list: one row per item, with sort and (TIRI only) filter. */
      items: {
        /** `{{module}}` is the product name (FanCam, TIRI, ...), which is never translated. */
        title: '{{module}} items',
        sort: {
          label: 'Sort items',
          reach: 'Most reach',
          events: 'Most events',
          recent: 'Recent activity'
        },
        /** The subtitle under the title, one per sort, saying what the order means. */
        sortHint: {
          reach: 'Ranked by reach',
          events: 'Ranked by total engagement',
          recent: 'Latest activity first'
        },
        playerStatsNote:
          'Combines live match-stats widget views and individual player-card views for the same game — open a row to see which event each one was.',
        refresh: 'Refresh the {{module}} item list',
        close: 'Close',
        empty: 'Nothing here yet',
        emptySub: 'No {{module}} activity matches this filter.',
        events: 'event',
        events_plural: 'events',
        /** When the row's latest event happened. */
        relative: {
          justNow: 'just now',
          minutes: '{{count}}m ago',
          minutes_plural: '{{count}}m ago',
          hours: '{{count}}h ago',
          hours_plural: '{{count}}h ago',
          days: '{{count}}d ago',
          days_plural: '{{count}}d ago'
        },
        range: '{{start}}–{{end}} of {{total}}',
        prev: 'Prev',
        next: 'Next'
      },
      drawer: {
        close: 'Close',
        /** Beside a `goalrush.kick` row: the kicks and goals that one batched row covers. */
        goalrushChip: '{{kicks}} kicks · {{goals}} goals',
        /** Level 1 of the drawer: who engaged with this item. */
        people: 'People',
        backToPeople: 'People',
        /** `{{count}}` is that fan's own event total, not the item's. */
        personEvents: '{{count}} event',
        personEvents_plural: '{{count}} events',
        lastActive: 'last {{time}}',
        noPeople: 'Nobody yet',
        noPeopleSub: 'No fan activity on this item in the current filter.',
        /**
         * The multiplier on a rolled-up run of Reach events. Separate from `personEvents` because
         * it sits inline after the verb — "viewed this item ×12" — rather than standing alone.
         */
        repeatCount: '×{{count}}',
        /** Game Stat's rolled-up reach rows, shown as their own line below the label instead of an inline ×N. */
        reachCount: 'Reach {{count}}',
        /** Fallback label for Game Stat reach events whose eventType has no entry above (e.g. an
         *  older, since-renamed event) — reads as Game Stat rather than the generic "viewed this". */
        playerStatsReachFallback: 'Viewed Player Stats',
        /** Note above a fan's timeline: why one fan's views can appear as several rows. */
        groupedByHour: 'Repeated views are grouped by the hour they happened in.',
        deletedUser: 'Deleted user',
        /**
         * The outcome chip on a `tiri.tagit.submit` row. The glyph is carried IN the string,
         * not concatenated in JSX, so a locale can drop it, swap it or reorder it around the
         * word — CJK in particular does not want the ASCII space a template would force.
         */
        tagCorrect: '✓ correct',
        tagWrong: '✗ wrong',
        /**
         * Keyed by `metadata.trigger` verbatim, because one Tag It hint reaches a fan two ways
         * and only this field tells them apart: `wrongGuess` is written by
         * `api/tiri/tagit/submit.ts`, `tap` by the app when the fan taps the photo.
         */
        hintTrigger: {
          tap: 'tapped the photo',
          wrongGuess: 'after a wrong guess'
        },
        /**
         * A plain-language verb per event type, read as "<fan name> <verb>".
         *
         * THE NESTING IS THE EVENT TYPE. `eventType` is already a dotted path
         * (`tiri.tagit.submit`), and i18next's key separator is '.', so the drawer looks a label
         * up by interpolating the raw value straight into the key — there is no map in the JS to
         * keep in step. Adding a label for a new backend event is a locale edit and nothing else.
         *
         * Consequence worth knowing: these keys are NOT free-form. Each segment must match the
         * `eventType` the server writes (see the `logInsightEvent` call sites), so renaming one
         * here does not rename anything — it just stops the label resolving and drops the row to
         * the `bucketFallback` phrase below.
         */
        events: {
          fancam: {
            view: 'viewed this post',
            colorReact: 'reacted with a color',
            react: 'reacted',
            comment: 'commented',
            repost: 'reposted this',
            delete: 'deleted this post',
            challenge: { create: 'created this post' },
            live: { create: 'created this post' },
            arFilter: { apply: 'applied an AR filter' }
          },
          tiri: {
            upload: 'uploaded this item',
            /** A moderator (or a FanCam delete) removed the item. */
            delete: 'deleted this item',
            tagit: {
              view: 'viewed this item in Tag It',
              submit: 'tagged this item',
              hint: 'used the hint',
              definition: 'looked up a category'
            },
            rateit: {
              view: 'viewed this item in Rate It',
              submit: 'rated this item',
              /**
               * OPENED, not sent. `tiri.rateit.share` is written the moment the fan reaches the
               * Share screen (`openShare` in mobile's `RateItFeed.tsx`) — nothing downstream
               * reports whether a link was actually sent, so a label reading "shared this
               * moment" would overstate what the row proves. Keep the distinction in every
               * locale.
               */
              share: 'opened Share for this moment'
            }
          },
          goalrush: {
            view: 'opened GoalRush',
            kick: 'in this session'
          },
          fanwave: {
            view: 'opened the wave',
            tap: 'tapped the wave',
            /**
             * SAW the goal reached, nothing more. The app writes `fanwave.goalReached.view` when
             * its "Wave complete!" animation plays while the card is on screen; it does not mean
             * this fan's taps got the wave there. Keep that in every locale.
             */
            goalReached: { view: 'saw the wave reach its goal' }
          },
          fanchat: {
            view: 'opened the thread',
            message: 'commented on',
            react: 'reacted to a message',
            topic: {
              preview: 'opened the chat preview',
              join: 'joined the chat',
              leave: 'left the chat',
              message: 'sent a message',
              message_delete: 'deleted a message',
              draft: 'saved a chat draft',
              publish: 'published the chat',
              delete: 'deleted the chat'
            },
            allowance: { used: 'used a free post or reply' },
            limit: { reached: 'reached a free limit' },
            follow: { refused: 'was refused for not following', prompt_shown: 'was asked to follow' },
            paywall: { limit_shown: 'saw the paywall at a free limit' }
          },
          predictions: { vote: 'made a prediction' },
          quizzes: { answer: 'answered the quiz' },
          polls: { submit: 'voted in the poll' },
          playerStats: { liveEngagement: 'Viewed Live Score/Line Up' },
          rewards: {
            carousel: { view: 'viewed the rewards carousel' },
            card: { tap: 'tapped this reward' }
          },
          ptw: { gloryboard: { view: 'viewed the GloryBoard' } }
        },
        /**
         * Used when `events` has no entry for the event type — a module shipped an event the CMS
         * has not been taught to name yet. Keyed by bucket, which every event always carries, so
         * the row still says what KIND of engagement it was instead of breaking.
         */
        bucketFallback: {
          reach: 'viewed this',
          activity: 'interacted with this',
          creation: 'created this',
          participation: 'participated in this'
        },
        /** Last resort: an event whose bucket is also unrecognised. */
        genericAction: 'did something'
      }
    },
    reporting: {
      webhooks: {
        title: 'Webhook Delivery Logs',
        subtitle:
          'Monitor webhook delivery status and debug failures — no sensitive data is displayed.',
        securityNotice:
          'This view displays only non-sensitive metadata. Payload contents, authorization headers, signatures, PII, and internal secrets are never shown.',
        payloadNotice:
          'Payload contents are hidden for security. Only delivery metadata is displayed in this report.',
        empty: 'No webhook logs found for the selected filters.',
        totalResults: '{{count}} results',
        exportCsv: 'Export CSV',
        exporting: 'Exporting…',
        filters: {
          label: 'Filters',
          from: 'From',
          to: 'To',
          eventType: 'Event Type',
          status: 'Status',
          allTypes: 'All Types',
          allStatuses: 'All Statuses',
          apply: 'Apply',
          clear: 'Clear'
        },
        status: {
          pending: 'Pending',
          processing: 'Processing',
          completed: 'Completed',
          failed: 'Failed',
          retrying: 'Retrying'
        },
        summary: {
          total: 'Total',
          success: 'Success',
          completed: 'Completed',
          failed: 'Failed',
          processing: 'Processing',
          successRate: 'Success Rate'
        },
        cols: {
          eventId: 'Event ID',
          eventType: 'Event Type',
          endpoint: 'Endpoint',
          timestamp: 'Time (UTC)',
          status: 'Status',
          httpCode: 'HTTP Code',
          retries: 'Retries',
          duration: 'Duration',
          errorCategory: 'Error Category'
        },
        pagination: {
          page: 'Page {{page}} of {{totalPages}}',
          prev: 'Prev',
          next: 'Next'
        }
      }
    },
    ctaPresets: {
      defaultPresets: 'Default Presets',
      customPresets: 'Custom Presets',
      addACustomPreset: 'Add a custom preset',
      englishMessage: 'English message',
      japaneseMessage: 'Japanese message (optional)',
      noCustomPresetsYet: 'No custom presets yet.',
      teamPresets: 'Team Presets',
      noTeamPresetsYet: 'No team presets yet.'
    },
    p4pDay: {
      tab: 'P4P Day',
      campaignTitle: 'P4P Day campaign',
      campaignDescription:
        'The window fans can be enrolled in. Enforced entirely by the server — a fan\u2019s device clock never decides the cutoff.',
      enabledLabel: 'Campaign enabled',
      enabledDesc:
        'Runtime kill switch. Turning it off stops enrolment immediately without changing the window below.',
      startsAt: 'Starts at (UTC)',
      endsAt: 'Ends at (UTC)',
      inTokyo: 'In Tokyo: {{time}}',
      currently: 'Currently:',
      active: 'Active',
      notActive: 'Not active',
      badgesTitle: 'Badge Distribution',
      allBadges: 'All',
      remaining: '<num>{{count}}</num> remaining',
      awarded: '{{count}} awarded',
      total: '{{count}} total',
      disabledTitle: 'Campaign disabled for this environment',
      disabledDescription:
        'P4P_DAY_CAMPAIGN_ENABLED is not set on the server, so no campaign exists here and nothing can be configured. While it stays unset, no fan is enrolled, no badge is awarded and no team is auto-followed — whatever window was saved previously. Set it and restart the server to take part.',
      disabledSectionDescription: 'This environment is not taking part in the P4P Day campaign.',
      loadFailed: 'Could not load the P4P Day campaign.',
      datesRequired: 'Both a start and an end date are required.',
      endBeforeStart: 'The end date must be after the start date.',
      save: 'Save Changes',
      saving: 'Updating...',
      // Hand-awarding a badge from the user panel (UserPanel/components/P4PDayGift.js).
      award: {
        menuItem: 'Award P4P Day badge',
        title: 'Award P4P Day badge',
        intro:
          'This fan has no P4P Day badge. Choose a colour to award one by hand. It counts against stock exactly like a badge claimed in the app.',
        loading: 'Loading…',
        switchedOff: 'P4P Day is switched off in this environment.',
        notActive: "The P4P Day campaign is not active, so badges can't be awarded.",
        allSoldOut:
          'Every badge colour is out of stock. Top up inventory in General Settings → P4P Day.',
        outOfStock: 'Out of stock',
        left: '{{remaining}} / {{total}} left',
        awardButton: 'Award badge',
        confirmText:
          'Award a {{color}} badge to @{{username}}? This takes one from stock and makes them follow the campaign team. It cannot be undone here.',
        confirmButton: 'Yes, award badge',
        cancel: 'Cancel',
        close: 'Close',
        awarded: '{{color}} badge #{{badgeNo}} awarded.',
        revokedNote: 'Their badge was removed on {{date}}. Awarding gives them a new one.'
      },
      // Side panel opened from a badge card: the fans holding that badge, and revoking it.
      fans: {
        allTitle: 'All badges',
        count: '{{count}} fans',
        close: 'Close',
        empty: 'No fans hold this badge yet.',
        fanId: 'Fan ID',
        awardedOn: 'Awarded {{date}}',
        byAdmin: 'Admin',
        handedOver: 'Handed over',
        delete: 'Delete badge',
        confirm:
          'Remove this badge? It goes back into stock. The fan cannot claim another in the app, but an admin can award one again.',
        confirmNoRestock:
          'Remove this badge anyway? It will NOT go back into stock. The fan cannot claim another in the app, but an admin can award one again.',
        handedOverWarning: 'This fan has already been handed the physical gift at the booth.',
        confirmButton: 'Yes, delete badge',
        cancel: 'Cancel',
        revokedRestocked: 'Badge removed and returned to stock.',
        revokedNotRestocked: 'Badge removed. The gift was already handed over, so stock is unchanged.',
        revokedUnnumbered: 'Badge removed. It was issued before badges were numbered, so it was not returned to stock.',
        pageRange: '{{from}}–{{to}} of {{total}}',
        searchPlaceholder: 'Search name, username, email, fan ID or badge #',
        searchClear: 'Clear search',
        matches: '{{count}} matching',
        noMatches: 'No fans match “{{query}}”.',
        prevPage: 'Previous page',
        nextPage: 'Next page'
      }
    },
    // The team's FanChat 2.0 access switches (TeamPanel/components/FanChatAccessPanel.js).
    fanChatAccess: {
      title: 'FanChat access',
      description:
        'Choose which FanChat 2.0 actions need FanChat access (a plan, a campaign or a bypass) for this team. Anyone can still browse and preview chats.',
      join: {
        label: 'Joining a chat needs FanChat access',
        hint: 'When off, any signed-in fan can join a chat.',
        confirm:
          'Fans without FanChat access will see the paywall when they try to join a chat. Continue?'
      },
      send: {
        label: 'Sending messages needs FanChat access',
        hint: 'Also covers deleting their own messages. When off, any signed-in fan can send.',
        confirm:
          'Fans without FanChat access will see the paywall when they try to send a message. Continue?'
      },
      start: {
        label: 'Starting a chat needs FanChat access',
        hint: 'Also covers drafts, edits and publishing. When off, any signed-in fan can start a chat.',
        confirm:
          'Fans without FanChat access will see the paywall when they try to start a chat. Continue?'
      },
      limit: {
        label: 'Open chats per fan',
        hint: 'The most chats one fan can have open in this team at once. Leave empty for no limit. Chats already open stay open.',
        none: 'No limit',
        save: 'Save',
        invalid: 'Enter a whole number from 1 to {{max}}, or leave it empty for no limit.'
      },
      turnOn: 'Turn on',
      cancel: 'Cancel',
      lastChangedBy: 'Last changed by {{username}} on {{date}}',
      lastChanged: 'Last changed on {{date}}',
      usingDefaults: 'Using defaults (all on, no chat limit)',
      loadFailed: 'Could not load the FanChat access settings.'
    },
    // The Reports screen and its detail panel, for the FanChat 2.0 entity types.
    reports: {
      entityTypes: {
        fanchatTopic: 'FanChat topic',
        fanchatMessage: 'FanChat message'
      },
      fanchatTopic: {
        heading: 'Reported FanChat topic',
        unavailable: 'FanChat topic unavailable',
        removeConfirm:
          'Remove this chat? It disappears from FanChat and every member is told it was deleted.'
      },
      fanchatMessage: {
        heading: 'Reported FanChat message',
        unavailable: 'FanChat message unavailable',
        deletedNote: 'Deleted. This is the text as it was reported.',
        removeConfirm: 'Remove this message? Everyone in the chat will see it as deleted.'
      },
      remove: 'Remove',
      cancel: 'Cancel'
    },
    // Rows in General Settings → Notifications (NotificationsTab.js).
    notifications: {
      fanChatTopicFirstResponse: {
        label: 'FanChat: first reply to your chat',
        desc: 'Sent once to a chat’s creator when someone else posts in it for the first time.'
      },
      fanChatTopicReply: {
        label: 'FanChat: reply to your message',
        desc: 'Sent when someone replies to a fan’s message. Replies within a minute are combined.'
      },
      fanChatTopicDigest: {
        label: 'FanChat: new messages digest',
        desc: 'At most one every 15 minutes per chat, to members who are not in it and have its notifications on.'
      },
      fanChatTopicDeleted: {
        label: 'FanChat: chat deleted',
        desc: 'Sent to every member when a chat is deleted.'
      }
    }
  },
  pollQuizProfile: {
    // Shared (poll + quiz profile sections)
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    deleting: 'Deleting…',
    close: 'Close',
    activate: 'Activate',
    deactivate: 'Deactivate',
    inactive: 'Inactive',
    live: 'LIVE',
    chipClosed: 'Closed',
    seeAllCount: 'See all ({{count}})',
    seenThemAll: "You've seen them all.",
    // Polls section
    pollsTitle: 'Polls',
    allPolls: 'All polls',
    noPollsYet: 'No polls yet.',
    createFirstPoll: 'Create your first poll',
    createFirstPollSub: 'Ask fans a question. Earn-on-vote.',
    deletePollHeading: 'Delete poll?',
    deletePollText: 'This action cannot be undone. Existing votes will be removed.',
    pollDeleted: 'Poll deleted.',
    pollDeleteError: 'Could not delete the poll. Please try again.',
    pollSaved: 'Poll saved.',
    chipScheduled: 'Scheduled',
    chipHidden: 'Hidden',
    chipAuto: 'Auto',
    gameDay: 'Game day',
    pollLabel: 'Poll',
    gameDayPoll: 'Game-day poll',
    viewResults: 'View results',
    voteNow: 'Vote Now',
    pts: '{{count}} pts',
    modalPoll: 'Poll',
    statusOpen: 'Open',
    statusPollClosed: 'Poll Closed',
    submitting: 'Submitting…',
    earnPtsForVoting: "Earn {{count}} pts for voting. Your vote can't be changed.",
    voteSubmittedConfirm: "Vote submitted. Your vote can't be changed.",
    voteSubmittedConfirmPts: "Vote submitted · +{{points}} pts. Your vote can't be changed.",
    toastVoteSubmitted: 'Vote submitted.',
    toastVoteSubmittedPts: 'Vote submitted · +{{points}} pts',
    thisPollClosed: 'This poll is closed.',
    totalSubmissions: '{{count}} total submission',
    totalSubmissions_plural: '{{count}} total submissions',
    // Quick Quiz section
    quizTitle: 'Quick Quiz',
    allQuizzes: 'All Quick Quizzes',
    noQuizzesYet: 'No quizzes yet.',
    createSingleQuiz: 'Create single quiz',
    createSingleQuizSub: 'One daily or half-time quiz',
    bulkCreate: 'Bulk pre-create',
    bulkCreateSub: '7 / 15 / 30-day daily set',
    createFirstQuiz: 'Create your first quiz',
    createFirstQuizSub: 'Engage fans with a daily question. Earn-on-correct.',
    deleteQuizHeading: 'Delete quiz?',
    deleteQuizText: 'This action cannot be undone. Existing user responses will be kept.',
    quizDeleted: 'Quiz deleted.',
    quizSaved: 'Quiz saved.',
    quizzesCreated: 'Created {{count}} quiz.',
    quizzesCreated_plural: 'Created {{count}} quizzes.',
    chipAnswered: 'Answered',
    chipComingUp: 'Coming up',
    actionPlay: 'Play',
    actionViewResult: 'View result',
    signInToPlay: 'Sign in to play',
    signInToPlaySub: 'Join Playaz4Playaz to answer quizzes and earn points.',
    signUp: 'Sign up',
    resultCorrect: "That's correct!",
    resultNotQuite: 'Not quite.',
    earnedPts: 'You earned {{count}} pts.',
    betterLuck: 'Better luck next time.',
    submit: 'Submit',
    ptsAvailable: '{{count}} pts available',
    toastCorrect: 'Correct!',
    toastSubmitted: 'Submitted.'
  },
  /**
   * TIRI — the Rate It web landing (`screens/RateIt`).
   *
   * KEY PATHS ARE SHARED WITH MOBILE (`playaz4playaz-mobile`'s own `tiri.rateIt.*`) wherever the
   * two surfaces say the same thing, so a copy edit ports by pasting rather than by hunting for
   * the equivalent key. Keys that exist only here — the referral banner and the sign-up screen —
   * are the parts of the flow mobile has no counterpart for: mobile SENDS invites, the web
   * RECEIVES them.
   *
   * Only `en` is defined. `containers/Auth.js` initialises i18next with `fallbackLng: 'en'`, so
   * the other seven languages fall back rather than rendering a raw key.
   */
  tiri: {
    /** Used when a moment's owner did not populate — a deleted account, or a legacy row. */
    anonymousFan: 'fan',
    creatorPoints: '{{points}} points',
    viewCount: '{{views}} views',
    /** The wordmark in the feed header's lockup, beside the p4p mark. A brand name, so it is
        carried here only so the surrounding markup has no bare string — never translated. */
    sponsorPlaceHolder: 'TIRI',
    rateIt: {
      caption: 'Rate this Fan Moment – Solid, Great, or Epic',
      noContent: 'No moments to rate right now. Check back soon!',
      loadError: "Couldn't load Rate It right now.",
      submitError: "Couldn't save your rating. Try again.",
      /** Web-only: the shared moment is gone but the referral is still live. */
      sharedUnavailable: "That moment isn't available any more — here are others to rate.",
      close: 'Close',
      previousMoment: 'Previous moment',
      nextMoment: 'Next moment',
      // Keyed by the RateItRating value verbatim (solid/great/epic) — the backend enum defines
      // these ids, and the tile looks its label up from the id it was handed. Renaming a key
      // here silently empties a tile.
      ratings: {
        solid: 'Solid',
        great: 'Great',
        epic: 'Epic'
      },
      milestone: {
        // `{{count}}` is the server's `milestoneCount`, not a constant — the cycle length is
        // tuned during development and hardcoded copy would misreport it.
        //
        // `count` is i18next's plural trigger and this app runs `compatibilityJSON: 'v3'`, where
        // the BASE key is the singular and `_plural` is everything else. Both are spelled out so
        // a cycle length of 1 reads "1 moment!" rather than "1 moments!". Same rule applies to
        // every `{{count}}` key below.
        // "Rated" is accurate ONLY because `RateItFeed` gates this modal on a PURE rating
        // cycle (`milestoneBreakdown.tagit === 0`). The cycle is shared with Tag It in the app,
        // so relaxing that gate makes this string lie to a fan who mostly tagged.
        title: 'You rated {{count}} moment!',
        title_plural: 'You rated {{count}} moments!',
        continue: 'CONTINUE'
      },
      /** Web-only: this surface is the far end of a mobile invite. */
      referral: {
        // Rendered through <Trans>, so the markup is part of the string and the translator can
        // move the name within the sentence. Keep the tag name in step with the `components`
        // map in `RateItReferralBanner`.
        banner:
          '<strong>@{{name}}</strong> invited you — rate {{count}} moment and you both earn {{points}} points.',
        banner_plural:
          '<strong>@{{name}}</strong> invited you — rate {{count}} moments and you both earn {{points}} points.',
        // The same offer with the attribution dropped, for a link whose sender cannot be
        // resolved. The reward is still live, so the offer must still be stated.
        offer: 'Rate {{count}} moment and you both earn {{points}} points.',
        offer_plural: 'Rate {{count}} moments and you both earn {{points}} points.',
        // The end of a link: this fan already finished THIS invite. Per link, not per fan — a
        // second invite from anyone still opens the feed normally.
        completedTitle: "You've already redeemed this referral.",
        // Three bodies because a completed referral has three honest endings. `completedBody`
        // when a payout actually landed; `completedBodyNoPoints` when the invite completed but
        // paid nothing, because the reward was priced at zero — saying "earned 0 points" there
        // would read as a bug rather than as a rule; and `completedBodyNoSender` when the
        // referrer cannot be resolved, or the figure was never recorded, where claiming any
        // number would be an invention.
        completedBody: 'You and @{{name}} already earned {{points, number}} points together.',
        completedBodyNoPoints: 'You and @{{name}} already completed this invite together.',
        completedBodyNoSender: 'You already completed this invite.',
        // The award popup on the rating that completes the invite. `awardBodyNoSender` for a
        // referrer who cannot be resolved.
        awardBody:
          'You completed the invite. You and @{{name}} each earned {{points, number}} points.',
        awardBodyNoSender:
          'You completed the invite. You and your friend each earned {{points, number}} points.'
      },
      /** Web-only: mobile has no signed-out state for this flow. */
      auth: {
        signUpTitle: 'Sign up to start rating',
        signUpSubtitle:
          'Create a free account on Playaz4Playaz to rate moments and earn points with your friend.',
        loginTitle: 'Sign In',
        loginSubtitle: 'Sign in to rate this moment and earn points with your friend.',
        createAccount: 'Create Account',
        haveAccount: 'Already have an account?',
        needAccount: 'Need an account?',
        signIn: 'Sign in',
        signUp: 'Sign up'
      }
    }
  },
  countries: {
    sweden: 'Sweden',
    poland: 'Poland',
    france: 'France',
    japan: 'Japan',
    southAfrica: 'South Africa',
    germany: 'Germany',
    unitedKingdom: 'United Kingdom',
    unitedStates: 'United States',
    northMacedonia: 'North Macedonia'
  },
  referral: {
    selfReferralTitle: 'Invite a friend, not yourself',
    selfReferralBody:
      'This challenge rewards you and the friend who invited you — open the link they sent to join in.',
    startFailedTitle: "Couldn't start this challenge",
    startFailedBody: 'Something went wrong. Check your connection and try again.',
    tryAgain: 'Try again',
    yourFriend: 'your friend',
    alreadyCompletedTitle: "You've already completed this",
    alreadyCompletedBody:
      'You and {{friendName}} already earned {{points, number}} points together for this challenge.',
    authGateBody: 'Sign up to unlock {{teamName}}’s fancam challenge.',
    authGateBodySignIn: 'Sign in to unlock {{teamName}}’s fancam challenge.',
    awardTitle: 'You did it!',
    awardBonusPts: '+{{points}} pts',
    // <strong> is markup <Trans> interprets — keep the tag name in step with the
    // `components` map in ReferralAwardModal.
    awardBody:
      'You viewed <strong>{{count}} FanCam moment</strong>. You and your friend each earned <strong>{{points}} points</strong>.',
    awardBody_plural:
      'You viewed <strong>{{count}} FanCam moments</strong>. You and your friend each earned <strong>{{points}} points</strong>.',
    awardContinue: 'Continue Playing'
  }
};
